<template>
    <div ref="qualityAssuranceView">
        <WeightValidation ref="WeightValidation"></WeightValidation>
        <PhotoWidget ref="PhotoWidget"></PhotoWidget>
        <ImageLightBox ref="ImageLightBox"></ImageLightBox>
        <GenericPopups ref="GenericPopups"></GenericPopups>
        <LoadingSpinner :busy="loading"></LoadingSpinner>
        <b-card v-if="order && !loading">
            <template v-slot:header>
                <OrderCardHeader :order="order"></OrderCardHeader>
            </template>

            <!--compliance section-->
            <b-card header="title" header-class="font-weight-bold" id="compliance-section">
                <template v-slot:header>
                    <div class="d-flex justify-content-between">
                        <span>538 Compliance</span>
                        <b-button @click="verifyAllCompliance" size="sm" variant="success" :disabled="working || !_canEdit">
                            <i class="fa-solid fa-check mr-1 fa-xs"></i>
                            Mark All Compliance as Verified
                        </b-button>
                    </div>
                </template>
                <b-row>
                    <b-col>
                        <h6 class="mb-3">
                            <i v-if="compliance.signature_card.isSaving" class="fa-solid fa-spinner mr-1 fa-spin"></i>
                            <i v-else class="fa-solid fa-file-check mr-1"></i>Signature Card
                        </h6>
                        <b-row>
                            <b-col>
                                <b-form-group label-for="signature-card-verified">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-file-check mr-1"></i>Verified?
                                        </span>
                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            class="nice-toggle-success"
                                            id="signature-card-verified"
                                            name="signature-card-verified"
                                            v-model="compliance.signature_card.verified"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-for="signature-card-error" label-class="label">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-exclamation-circle mr-1"></i>Error
                                        </span>
                                    </template>
                                    <b-form-checkbox
                                            class="nice-toggle-error"
                                            size="sm"
                                            id="signature-card-error"
                                            name="signature-card-error"
                                            v-model="compliance.signature_card.error"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <template>
                                <div class="editable">
                                    <div @click="compliance.signature_card.isEditing = !compliance.signature_card.isEditing"
                                        v-if="!compliance.signature_card.isEditing" class="data pointer editable">

                                        <div class="small editable">
                                            <div v-if="true" class="view">
                                                <div v-if="order.card_present === true">
                                                    <i class="text-primary fa-solid fa-check-circle mr-1"></i>
                                                    <b>Signature Card Marked as Provided</b>
                                                </div>
                                                <div v-else>
                                                    <i class="text-danger fa-solid fa-check-circle mr-1"></i>
                                                    <b>Signature Card Marked as Not Provided</b>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <b-row class="edits"
                                    v-if="compliance.signature_card.isEditing == true && compliance.signature_card.isSaved == false">
                                    <b-col>
                                        <b-form-group label-for="card-present" label-class="label" v-b-tooltip.hover
                                            :title="order.card_present ? 'yes' : 'no'">
                                            <template v-slot:label>
                                                <span class="label">
                                                    <i class="fa-light fa-file-check mr-1"></i>Card Present?
                                                </span>

                                            </template>
                                            <b-form-checkbox
                                                    id="card-present"
                                                    class="nice-toggle-success"
                                                    v-model="order.card_present"
                                                    name="check-button"
                                                    :disabled="working || !_canEdit"
                                                    switch>
                                            </b-form-checkbox>
                                        </b-form-group>
                                    </b-col>
                                    <div class="controls mt-1 text-right">
                                        <i @click="cancelEdits" data-editing="signature_card"
                                            v-if="!compliance.signature_card.isSaving"
                                            class="fa-solid fa-times text-danger pointer">
                                        </i>
                                        <i @click="saveEdits" v-if="!compliance.signature_card.isSaving"
                                            data-editing="signature_card"
                                            class="fa-solid fa-save text-success pointer ml-2">
                                        </i>
                                        <i v-if="compliance.signature_card.isSaving"
                                            class="fa-solid fa-spinner fa-spin"></i>
                                    </div>

                                </b-row>
                            </template>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div v-if="compliance.signature_card.error">
                                    <b-select size="sm" :options="compliance.signature_card.error_options"
                                        v-model="compliance.signature_card.error_description"
                                        :disabled="working || !_canEdit">
                                    </b-select>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col>
                        <h6 class="mb-3"><i v-if="compliance.signature.isSaving"
                                class="fa-solid fa-spinner mr-1 fa-spin"></i><i v-else
                                class="fa-solid fa-signature mr-1"></i>Signature
                        </h6>
                        <b-row>
                            <b-col>
                                <b-form-group label-for="signature-verified">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-file-check mr-1"></i>Verified?
                                        </span>
                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="signature-verified"
                                            name="check-button"
                                            class="nice-toggle-success"
                                            v-model="compliance.signature.verified"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-for="signature-error">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-exclamation-circle mr-1"></i>Error
                                        </span>
                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="signature-error"
                                            class="nice-toggle-error"
                                            name="check-button"
                                            v-model="compliance.signature.error"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <template>
                                    <div class="editable">
                                        <div @click="compliance.signature.isEditing = !compliance.signature.isEditing"
                                            v-if="!compliance.signature.isEditing" class="data pointer">

                                            <div class="small editable">
                                                <div>
                                                    <div v-if="true">
                                                        <div v-if="order.card_signed === true">
                                                            <i class="text-primary fa-solid fa-check-circle mr-1"></i>
                                                            <b>Signature Card Marked as Signed</b>
                                                        </div>
                                                        <div v-else>
                                                            <i class="text-danger fa-solid fa-check-circle mr-1"></i>
                                                            <b>Signature Card Marked as Not Signed</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <b-row class="edits"
                                        v-if="compliance.signature.isEditing == true && compliance.signature_card.isSaved == false">
                                        <b-col>
                                            <b-form-group label-for="card-signed" label-class="label" v-b-tooltip.hover
                                                :title="order.card_signed ? 'yes' : 'no'">
                                                <template v-slot:label>
                                                    <span class="label">
                                                        <i class="fa-light fa-file-check mr-1"></i>Card Signed?
                                                    </span>

                                                </template>
                                                <b-form-checkbox
                                                        id="card-signed"
                                                        class="nice-toggle-success"
                                                        v-model="order.card_signed"
                                                        name="check-button"
                                                        :disabled="working || !_canEdit"
                                                        switch>
                                                </b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                        <div class="controls mt-1 text-right">
                                            <i @click="cancelEdits" data-editing="signature"
                                                v-if="!compliance.signature.isSaving"
                                                class="fa-solid fa-times text-danger pointer">
                                            </i>
                                            <i @click="saveEdits" v-if="!compliance.signature.isSaving"
                                                data-editing="signature" class="fa-solid fa-save text-success pointer ml-2">
                                            </i>
                                            <i v-if="compliance.signature.isSaving" class="fa-solid fa-spinner fa-spin"></i>
                                        </div>

                                    </b-row>
                                </template>
                                <div v-if="compliance.signature.error">
                                    <b-select size="sm" :options="compliance.signature.error_options"
                                        v-model="compliance.signature.error_description" :disabled="working || !_canEdit">
                                    </b-select>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col>
                        <h6 class="mb-3"><i v-if="compliance.identification.isSaving"
                                class="fa-solid fa-spinner mr-1 fa-spin"></i><i v-else
                                class="fa-solid fa-address-card mr-1"></i>Identification
                        </h6>
                        <b-row>
                            <b-col>
                                <b-form-group label-for="identification-verified">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-file-check mr-1"></i>Verified?
                                        </span>

                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="identification-verified"
                                            class="nice-toggle-success"
                                            name="check-button"
                                            v-model="compliance.identification.verified"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-for="identification-error">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-exclamation-circle mr-1"></i>Error
                                        </span>

                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="identification-error"
                                            v-model="compliance.identification.error"
                                            class="nice-toggle-error"
                                            name="check-button"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <template>
                                    <div class="editable small">

                                        <div class="editable">
                                            <div @click="compliance.identification.isEditing = !compliance.identification.isEditing"
                                                v-if="!compliance.identification.isEditing" class="data pointer">

                                                <div v-if="compliance.identification.isSaved" class="onSave saveBlock">
                                                    <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                </div>
                                                <div><b>Type: </b>{{ order.customer.identity_type | titleCase }}</div>
                                                <template v-if="order.customer.identity_type == 'passport'">
                                                    <div><b>Country: </b>{{
                                                        order.customer.identity_country | titleCase
                                                    }}
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div><b>State: </b>{{ order.customer.identity_state | titleCase }}
                                                    </div>
                                                </template>
                                                <div v-if="_canViewMaskedData"><b>Number: </b>{{
                                                    order.customer.identity_number }}</div>
                                                <div v-else><b>Number: </b>{{ order.customer.identity_number_masked }}</div>
                                                <div><b>Expiration: </b>{{ formatDate(order.customer.identity_expiration) }}</div>
                                            </div>

                                            <div class="edits"
                                                v-if="compliance.identification.isEditing == true && compliance.identification.isSaved == false">
                                                <div class="inputs">
                                                    <b-select size="sm" v-model="order.customer.identity_type"
                                                        :disabled="working || !_canEdit"
                                                        :options="[{ value: 'drivers-license', text: 'Drivers License' }, { value: 'passport', text: 'Passport' }, { value: 'state-issued', text: 'State ID' }, { value: 'military-id', text: 'Military ID' }]">
                                                    </b-select>
                                                    <template v-if="order.customer.identity_type == 'Passport'">
                                                        <b-select class="my-1" size="sm" :disabled="working || !_canEdit"
                                                            v-model="order.customer.identity_country" :options="['US']">
                                                        </b-select>
                                                    </template>
                                                    <template v-else>
                                                        <multiselect v-model="_state" :options="US_STATES_LIST_UNFILTERED"
                                                            :optionHeight="8" group-values="types" group-label="name"
                                                            :searchable="true" :close-on-select="true" :show-labels="false"
                                                            :group-select="false" track-by="id" label="name"
                                                            :disabled="working || !_canEdit" placeholder="Select State">
                                                        </multiselect>
                                                    </template>
                                                    <b-form-input size="sm" :disabled="working || !_canEdit"
                                                        v-model="order.customer.identity_number">
                                                    </b-form-input>
                                                    <b-form-input type="date" v-model="order.customer.identity_expiration" id="id-exp-field"
                                                        size="sm" lazy :disabled="working || !_canEdit" class="">
                                                    </b-form-input>
                                                </div>
                                                <div class="controls mt-1 text-right">
                                                    <i @click="cancelEdits" data-editing="identification"
                                                        v-if="!compliance.identification.isSaving"
                                                        class="fa-solid fa-times text-danger pointer">
                                                    </i>
                                                    <i @click="saveEdits" v-if="!compliance.identification.isSaving"
                                                        data-editing="identification"
                                                        class="fa-solid fa-save text-success pointer ml-2">
                                                    </i>
                                                    <i v-if="compliance.identification.isSaving"
                                                        class="fa-solid fa-spinner fa-spin"></i>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </template>
                                <template v-if="compliance.identification.error">
                                    <b-select size="sm" :options="compliance.identification.error_options"
                                        v-model="compliance.identification.error_description"
                                        :disabled="working || !_canEdit">
                                    </b-select>
                                </template>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col>
                        <h6 class="mb-3"><i v-if="compliance.dob.isSaving" class="fa-solid fa-spinner mr-1 fa-spin"></i><i
                                v-else class="fa-solid fa-calendar mr-1"></i>Date of Birth / SSN</h6>
                        <b-row no-gutters>
                            <b-col>
                                <b-form-group label-for="dob-verified" label-cols="12">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-file-check mr-1"></i>DOB Verified?
                                        </span>

                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="dob-verified"
                                            name="check-button"
                                            class="nice-toggle-success"
                                            v-model="compliance.dob.verified"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-for="dob-error" label-cols="12">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-exclamation-circle mr-1"></i>DOB Error
                                        </span>

                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="dob-error"
                                            name="check-button"
                                            class="nice-toggle-error"
                                            v-model="compliance.dob.error"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="small">
                                    <div>

                                        <div class="editable">
                                            <div @click="compliance.dob.isEditing = !compliance.dob.isEditing"
                                                v-if="!compliance.dob.isEditing" class="data pointer">

                                                <div v-if="compliance.dob.isSaved" class="onSave saveBlock">
                                                    <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                </div>

                                                <div><b>DOB: </b>{{ formatDate(order.customer.dob) }}</div>
                                            </div>

                                            <div class="edits"
                                                v-if="compliance.dob.isEditing == true && compliance.dob.isSaved == false">
                                                <b-form-input type="date" v-model="order.customer.dob" id="dob-field"
                                                    size="sm" lazy :disabled="working || !_canEdit" class=""></b-form-input>

                                                <div class="controls mt-1 text-right">
                                                    <i @click="cancelEdits" data-editing="dob"
                                                        v-if="!compliance.dob.isSaving"
                                                        class="fa-solid fa-times text-danger pointer">
                                                    </i>
                                                    <i @click="saveEdits" v-if="!compliance.dob.isSaving" data-editing="dob"
                                                        class="fa-solid fa-save text-success pointer ml-2">
                                                    </i>
                                                    <i v-if="compliance.dob.isSaving"
                                                        class="fa-solid fa-spinner fa-spin"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="compliance.dob.error">
                                    <b-select size="sm" :options="compliance.dob.error_options"
                                        v-model="compliance.dob.error_description" :disabled="working || !_canEdit">
                                    </b-select>
                                </div>
                            </b-col>
                        </b-row>

                        <hr class="my-1"/>

                        <b-row no-gutters>
                            <b-col>
                                <b-form-group label-for="ssn-verified" label-cols="12">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-file-check mr-1"></i>SSN Verified?
                                        </span>

                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="ssn-verified"
                                            name="check-button"
                                            class="nice-toggle-success"
                                            v-model="compliance.ssn_last_4.verified"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-for="ssn-error" label-cols="12">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-exclamation-circle mr-1"></i>SSN Error
                                        </span>

                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="ssn-error"
                                            name="check-button"
                                            class="nice-toggle-error"
                                            v-model="compliance.ssn_last_4.error"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <div class="small">
                                    <div>
                                        <div class="editable">
                                            <div @click="compliance.ssn_last_4.isEditing = !compliance.ssn_last_4.isEditing"
                                                v-if="!compliance.ssn_last_4.isEditing" class="data pointer">

                                                <div v-if="compliance.ssn_last_4.isSaved" class="onSave saveBlock">
                                                    <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                </div>

                                                <div v-if="_canViewMaskedData"><b>SSN Last 4: </b>{{
                                                    order.customer.ssn_last_4 }}</div>
                                                <div v-else><b>SSN Last 4: </b>{{ order.customer.ssn_last_4_masked }}</div>
                                            </div>

                                            <div class="edits"
                                                v-if="compliance.ssn_last_4.isEditing == true && compliance.ssn_last_4.isSaved == false">
                                                <validation-observer ref="payment_method_observer"
                                                        v-slot="{ passes, invalid, errors }">
                                                    <validation-provider :rules="{ required: false, digits: 4 }"
                                                            immediate name="ssn_last_4" v-slot="validationContext">
                                                        <b-form-input v-model="order.customer.ssn_last_4"
                                                            :formatter="$inputSanitizer.toDigits"
                                                            id="ssn-field"
                                                            size="sm"
                                                            :state="getValidationState(validationContext)"
                                                            :disabled="working || !_canEdit" class=""></b-form-input>
                                                    </validation-provider>
                                                </validation-observer>

                                                <div class="controls mt-1 text-right">
                                                    <i @click="cancelEdits" data-editing="ssn_last_4"
                                                        v-if="!compliance.ssn_last_4.isSaving"
                                                        class="fa-solid fa-times text-danger pointer">
                                                    </i>
                                                    <i @click="saveEdits" v-if="!compliance.ssn_last_4.isSaving" data-editing="ssn_last_4"
                                                        class="fa-solid fa-save text-success pointer ml-2">
                                                    </i>
                                                    <i v-if="compliance.ssn_last_4.isSaving"
                                                        class="fa-solid fa-spinner fa-spin"></i>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div v-if="compliance.ssn_last_4.error">
                                    <b-select size="sm" :options="compliance.ssn_last_4.error_options"
                                        v-model="compliance.ssn_last_4.error_description" :disabled="working || !_canEdit">
                                    </b-select>
                                </div>
                            </b-col>
                        </b-row>

                    </b-col>

                    <b-col>
                        <h6 class="mb-3"><i v-if="compliance.payment.isSaving"
                                class="fa-solid fa-spinner mr-1 fa-spin"></i><i v-else
                                class="fa-solid fa-university mr-1"></i>Payment/Financial
                        </h6>
                        <b-row>
                            <b-col>
                                <b-form-group label-for="payment-verified">
                                    <template v-slot:label>
                                        <span class="label">
                                             <i class="fa-light fa-file-check mr-1"></i>Verified?
                                        </span>

                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="payment-verified"
                                            name="check-button"
                                            class="nice-toggle-success"
                                            v-model="compliance.payment.verified"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-for="payment-error">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-exclamation-circle mr-1"></i>Error
                                        </span>

                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            id="payment-error"
                                            name="check-button"
                                            class="nice-toggle-error"
                                            v-model="compliance.payment.error"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="small">
                                    <div v-if="true">

                                        <div class="editable">
                                            <div @click="compliance.payment.isEditing = !compliance.payment.isEditing"
                                                v-if="!compliance.payment.isEditing" class="data pointer">

                                                <div v-if="compliance.payment.isSaved" class="onSave saveBlock">
                                                    <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                </div>

                                                <div><b>Method: </b>{{ order.payment_method | titleCase }}</div>
                                                <template v-if="order.payment_method == 'paypal'">
                                                    <div><b>PayPal Email: </b>{{
                                                        order.paypal_email ? order.paypal_email : '-'
                                                    }}
                                                    </div>
                                                    <div><b>Customer Email: </b>{{
                                                        order.customer.email ? order.customer.email : '-'
                                                    }}
                                                    </div>
                                                </template>
                                                <template v-if="order.payment_method == 'direct-deposit'">
                                                    <div v-if="_canViewMaskedData">
                                                        <div><b>Routing Number: </b>{{ order.bank_routing }}</div>
                                                        <div><b>Account Number: </b>{{ order.bank_account }}</div>
                                                    </div>
                                                    <div v-else>
                                                        <div><b>Routing Number: </b>{{ order.bank_routing_masked }}</div>
                                                        <div><b>Account Number: </b>{{ order.bank_account_masked }}</div>
                                                    </div>
                                                    <div class="text-success"
                                                        v-if="order.bank_routing_valid && order.bank_routing_valid != true">
                                                        <i class="fa-regular fa-check-circle mr-1"></i>{{
                                                            order.bank_routing_valid }}</div>
                                                    <div class="text-danger" v-if="!order.bank_routing_valid"><i
                                                            class="fa-regular fa-times-circle mr-1"></i>BANK NOT FOUND</div>
                                                </template>
                                            </div>

                                            <div class="edits"
                                                v-if="compliance.payment.isEditing == true && compliance.payment.isSaved == false">

                                                <div class="inputs">
                                                    <validation-observer ref="payment_method_observer"
                                                        v-slot="{ passes, invalid, errors }">
                                                        <b-select class="mb-1" size="sm" v-model="order.payment_method"
                                                            :disabled="working || !_canEdit"
                                                            :options="[{ value: 'company-check', text: 'Company Check' }, { value: 'paypal', text: 'Paypal' }, { value: 'direct-deposit', text: 'Direct Deposit' }]">
                                                        </b-select>

                                                        <template v-if="order.payment_method == 'paypal'">
                                                            <label class="mb-0" for="paypal-email">Paypal Email
                                                                Address</label>

                                                            <validation-provider :rules="{ required: true, email: true }"
                                                                immediate name="paypal_email" v-slot="validationContext">
                                                                <b-form-input class="mt-1" size="sm" type="text"
                                                                    :disabled="working || !_canEdit" id="paypal-email"
                                                                    :state="getValidationState(validationContext)"
                                                                    v-b-tooltip.hover
                                                                    :title="getValidationComplaint(validationContext)"
                                                                    v-model="order.paypal_email">
                                                                </b-form-input>
                                                            </validation-provider>
                                                            <div class="pt-1"><label class="mb-0"> Customer Email:
                                                                </label><br />{{
                                                                    order.customer.email ? order.customer.email : '-'
                                                                }}
                                                            </div>
                                                        </template>

                                                        <template v-if="order.payment_method == 'direct-deposit'">
                                                            <label class="mb-0" for="routing-number">Routing Number</label>

                                                            <validation-provider
                                                                :rules="{ required: true, regex: /^\d{9}$/ }" immediate
                                                                name="bank routing" v-slot="validationContext">
                                                                <b-form-input size="sm" :disabled="working || !_canEdit"
                                                                    id="routing-number"
                                                                    :formatter="$inputSanitizer.toDigits"
                                                                    :state="getValidationState(validationContext)"
                                                                    v-b-tooltip.hover
                                                                    :title="getValidationComplaint(validationContext)"
                                                                    v-model="order.bank_routing">
                                                                </b-form-input>
                                                            </validation-provider>
                                                            <label class="mb-0 mt-2" for="bank-account">Bank Account
                                                                Number</label>

                                                            <validation-provider :rules="{ required: true }" immediate
                                                                name="bank account" v-slot="validationContext">
                                                                <b-form-input size="sm" :disabled="working || !_canEdit"
                                                                    id="bank-account"
                                                                    :formatter="$inputSanitizer.toDigits"
                                                                    :state="getValidationState(validationContext)"
                                                                    v-b-tooltip.hover
                                                                    :title="getValidationComplaint(validationContext)"
                                                                    v-model="order.bank_account">
                                                                </b-form-input>
                                                            </validation-provider>
                                                        </template>
                                                    </validation-observer>
                                                </div>

                                                <div class="controls mt-1 text-right">
                                                    <i @click="cancelEdits" data-editing="payment"
                                                        v-if="!compliance.payment.isSaving"
                                                        class="fa-solid fa-times text-danger pointer">
                                                    </i>
                                                    <i @click="saveEdits" v-if="!compliance.payment.isSaving"
                                                        data-editing="payment"
                                                        class="fa-solid fa-save text-success pointer ml-2">
                                                    </i>
                                                    <i v-if="compliance.payment.isSaving"
                                                        class="fa-solid fa-spinner fa-spin"></i>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div v-if="compliance.payment.error">
                                    <b-select size="sm" :options="compliance.payment.error_options"
                                        v-model="compliance.payment.error_description" :disabled="working || !_canEdit">
                                    </b-select>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col>
                        <h6 class="mb-3">
                            <i v-if="compliance.bonus_card.isSaving" class="fa-solid fa-spinner mr-1 fa-spin"></i>
                            <i v-else class="fa-solid fa-certificate mr-1"></i>5% Bonus Card
                        </h6>
                        <b-row>
                            <b-col>
                                <b-form-group label-for="bonus-card-verified">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-file-check mr-1"></i>Verified?
                                        </span>
                                    </template>
                                    <b-form-checkbox
                                            size="sm"
                                            class="nice-toggle-success"
                                            id="bonus-card-verified"
                                            name="bonus-card-verified"
                                            v-model="compliance.bonus_card.verified"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-for="bonus-card-error" label-class="label">
                                    <template v-slot:label>
                                        <span class="label">
                                            <i class="fa-light fa-exclamation-circle mr-1"></i>Error
                                        </span>
                                    </template>
                                    <b-form-checkbox
                                            class="nice-toggle-error"
                                            size="sm"
                                            id="bonus-card-error"
                                            name="bonus-card-error"
                                            v-model="compliance.bonus_card.error"
                                            switch :disabled="working || !_canEdit">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <template>
                                <div class="editable">
                                    <div @click="compliance.bonus_card.isEditing = !compliance.bonus_card.isEditing"
                                        v-if="!compliance.bonus_card.isEditing" class="data pointer editable">

                                        <div class="small editable">
                                            <div v-if="true" class="view">
                                                <div v-if="order.bonus_card_present === true">
                                                    <i class="text-primary fa-solid fa-check-circle mr-1"></i>
                                                    <b>Bonus Card Marked as Provided</b>
                                                </div>
                                                <div v-else>
                                                    <i class="text-danger fa-solid fa-check-circle mr-1"></i>
                                                    <b>Bonus Card Marked as Not Provided</b>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <b-row class="edits"
                                    v-if="compliance.bonus_card.isEditing == true && compliance.bonus_card.isSaved == false">
                                    <b-col>
                                        <b-form-group label-for="bonus_card-present" label-class="label" v-b-tooltip.hover
                                            :title="order.bonus_card_present ? 'yes' : 'no'">
                                            <template v-slot:label>
                                                <span class="label">
                                                    <i class="fa-light fa-file-check mr-1"></i>Bonus Card Present?
                                                </span>

                                            </template>
                                            <b-form-checkbox
                                                    id="bonus_card-present"
                                                    class="nice-toggle-success"
                                                    v-model="order.bonus_card_present"
                                                    name="check-button"
                                                    :disabled="working || !_canEdit || !_canEditBonus"
                                                    switch>
                                            </b-form-checkbox>
                                        </b-form-group>
                                    </b-col>
                                    <div class="controls mt-1 text-right">
                                        <i @click="cancelEdits" data-editing="bonus_card"
                                            v-if="!compliance.bonus_card.isSaving"
                                            class="fa-solid fa-times text-danger pointer">
                                        </i>
                                        <i @click="saveEdits" v-if="!compliance.bonus_card.isSaving"
                                            data-editing="bonus_card"
                                            class="fa-solid fa-save text-success pointer ml-2">
                                        </i>
                                        <i v-if="compliance.bonus_card.isSaving"
                                            class="fa-solid fa-spinner fa-spin"></i>
                                    </div>

                                </b-row>
                            </template>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div v-if="compliance.bonus_card.error">
                                    <b-select size="sm" :options="compliance.bonus_card.error_options"
                                        v-model="compliance.bonus_card.error_description"
                                        :disabled="working || !_canEdit">
                                    </b-select>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="mt-2">
                                <div v-if="order.bonus_information.five_percent">
                                    <span class="label">5% Bonus added by:</span><br>
                                    <small><strong>{{ order.bonus_information.five_percent}}</strong></small>
                                </div>
                                <div v-if="order.bonus_information.ten_percent">
                                    <span class="label">10% Bonus added by:</span><br>
                                    <small><strong>{{ order.bonus_information.ten_percent}}</strong></small>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
            <!--end compliance section-->


            <!--melt table-->
            <b-card no-body>
                <template v-slot:header>
                    <span class="font-weight-bold">Bag and Inventory Confirmation</span>

                        <b-button-group class="float-right" size="sm">
                            <b-button v-on:click="expandAll">
                                <i class="fas fa-expand fa-fw"></i> Expand All
                            </b-button>
                            <b-button v-on:click="collapseAll">
                                <i class="fas fa-compress fa-fw"></i> Collapse All
                            </b-button>
                        </b-button-group>
                </template>

                <template v-for="(value, name, index) in _getBagsByMetal">

                    <b-card class="mb-0" header-class="table-header-bg" body-class="p-0" :key="index"
                        :header="name | titleCase" v-if="name != 'other'">
                        <template v-slot:header>
                            <h4 class="mb-0">{{ name | titleCase }}</h4>
                        </template>
                        <b-table :tbody-tr-class="rowClass" class="text-center" head-variant="dark" v-if="!loading_items"
                            :fields="['verified?', 'open_bag', 'purity', 'items', 'bag_size', 'expected_weight', 'error', 'label']"
                            :items="_getBagsByMetal[name]">
                            <!--verified-->
                            <template class="m-4" v-slot:cell(verified?)="data">
                                <b-button :variant="data.item.verified ? 'success' : 'light'" class="cursor-pointer"
                                    v-model="data.item.verified" size="sm" @click="setQA('bag', data.item, 'verify')"
                                    :disabled="working || !_canEdit">
                                    <i class="far" :class="data.item.verified ? 'fa-check-square' : 'fa-square'"></i>
                                </b-button>
                            </template>

                            <!--open-bag-->
                            <template v-slot:cell(open_bag)="row">
                                <b-button variant="light" size="sm" @click="row.toggleDetails" class="cursor-pointer"
                                    :disabled="working">
                                    <i class="fa-solid text-success"
                                        :class="row.detailsShowing ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                </b-button>
                            </template>


                            <!--BAG PURITY ITEMS-->
                            <template v-slot:row-details="data">
                                <b-row>
                                    <b-col offset="1">
                                        <!--                                                    <b-card border-variant="light" body-class="p-0" class="mb-0">-->
                                        <b-table
                                                small
                                                outlined
                                                thead-class="font-weight-light font-italic text-muted"
                                                class="mb-3 font-xs"
                                                tbody-tr-class="font-weight-normal"
                                                :fields="['id', 'verified?','Error?','Label','Picture','item_details',
                                                                            'quantity','weight']"
                                                :items="_getMeltItems[data.item.bag_id]"
                                                :disabled="working || !_canEdit"
                                        >
                                            <!--id-->
                                            <template v-slot:cell(id)="data">
                                                <b-button variant="link"
                                                          :to="'/appraisals/appraise/'+$route.params.id+'/inventory/'+data.item.id + '?after_save=QA'">
                                                    {{ data.value }}
                                                </b-button>
                                            </template>
                                            <!--verified-->
                                            <template v-slot:cell(verified?)="data">
                                                <b-button
                                                        :variant="data.item.verified ? 'success': 'light' "
                                                        class="cursor-pointer"
                                                        @click="setQA('inventory', data.item, 'verify')"
                                                        :disabled="working || !_canEdit" size="sm">
                                                    <i class="far"
                                                       :class="data.item.verified ? 'fa-check-square': 'fa-square' "></i>
                                                </b-button>
                                            </template>

                                            <!--error?-->
                                            <template v-slot:cell(error?)="data">
                                                <b-form-checkbox class="cursor-pointer nice-toggle-error"
                                                    :checked="data.item.has_error" @change="displayErrorField(data.item)"
                                                    :id="'error-' + data.item.id" name="check-button" switch
                                                    :disabled="working || !_canEdit">
                                                </b-form-checkbox>
                                                <div v-if="data.item.has_error && seekSelectedType(data.item.error_type)"
                                                    class="small">
                                                    {{ seekSelectedType(data.item.error_type) }}
                                                </div>
                                                <div v-if="data.item.has_error && data.item.description" class="small">
                                                    {{ data.item.description }}
                                                </div>
                                                <b-popover title="Describe Error" :target="'error-' + data.item.id"
                                                    :show.sync="compliance_edits.currentEdit == data.item.id"
                                                    placement="bottom" triggers="">
                                                    <b-select :options="compliance_edits.types"
                                                        v-model="compliance_edits.selected_type"
                                                        placeholder="Select Error Type" @change="$forceUpdate()">

                                                    </b-select>
                                                    <b-select
                                                        v-if="compliance_edits.subCatagory[String(compliance_edits.selected_type)] != undefined"
                                                        class="mt-2" placeholder="Select Error-Subtype Type"
                                                        :options="compliance_edits.subCatagory[String(compliance_edits.selected_type)]"
                                                        v-model="compliance_edits.subCatagoryText">
                                                    </b-select>
                                                    <b-form-input v-else-if="!!(compliance_edits.selected_type)"
                                                        v-model="compliance_edits.subCatagoryText"
                                                        placeholder="Enter Description" class="mt-2">

                                                    </b-form-input>
                                                    <hr>
                                                    <div class="">
                                                        <b-button class="float-right mb-2" variant="success"
                                                            @click="saveErrorDescription(data.item)" size="sm">
                                                            <i class="fa-solid fa-check fa-fw"></i>
                                                            Save
                                                        </b-button>

                                                        <b-button class="float-right mb-2 mr-1" @click="cancelErrorField"
                                                            size="sm">
                                                            <i class="fa-solid fa-check fa-times"></i>
                                                            Cancel
                                                        </b-button>
                                                    </div>
                                                </b-popover>
                                            </template>

                                            <!--label-->
                                            <template v-slot:cell(label)="data">
                                                <b-button variant="light" class="cursor-pointer" :disabled="working"
                                                    size="sm" @click="printLabel('item', data.item)">
                                                    <i class="fa-regular fa-print"></i>
                                                </b-button>
                                            </template>

                                            <!--picture-->
                                            <template v-slot:cell(picture)="data">
                                                <div class="pic position-relative pointer"
                                                    @click="openLightBox(data.item.media)">
                                                    <b-badge pill v-if="data.item.media.length > 1" variant="primary"
                                                        class="position-absolute text-white m-1">
                                                        <i class="fa-solid fa-images "></i> {{ data.item.media.length }}
                                                    </b-badge>
                                                    <img width="80px"
                                                        :src="data.item.media[0] ? data.item.media[0].url : ''" />
                                                </div>

                                            </template>

                                            <!--details-->
                                            <template v-slot:cell(item_details)="data">
                                                {{ data.item.type_name }}
                                                <div class="font-xxs" v-if="data.item.brand_name">Brand: {{
                                                    data.item.brand_name }}</div>
                                                <template
                                                    v-if="data.item.children.length > 1 || data.item.type.item_category_id == 13 || data.item.type.item_category_id == 2">
                                                    <div>
                                                        <a class="pointer" @click="toggleAllDetails(data)"><small>
                                                                <i class="fa-solid text-success"
                                                                    :class="data.detailsShowing ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                                                {{ data.detailsShowing ? 'Hide' : 'Show' }}
                                                                Sub Items</small></a>
                                                    </div>
                                                </template>
                                            </template>
                                            <!-- row details -->
                                            <template v-slot:row-details="data">
                                                <b-container>
                                                    <b-row align-h="center">
                                                        <b-col cols="12" class="p-0">

                                                            <!-- Child Items -->
                                                            <b-table small outlined fixed bordered
                                                                thead-tr-class="bg-secondary"
                                                                class="font-weight-normal"
                                                                :fields="[
                                                                    { key: 'class_name', label: 'type' },
                                                                    { key: 'tare_weight', label: 'weight' },
                                                                    'quantity',
                                                                    { key: 'details', label: 'Details' },
                                                                ]" :items="data.item.children">
                                                                <!--head and cell styles-->
                                                                <template v-slot:head()="data">
                                                                    <small>{{
                                                                        data.label | titleCase
                                                                    }}</small>
                                                                </template>
                                                                <template v-slot:cell()="data">
                                                                    <small>{{ (data.value || '-') | titleCase }}</small>
                                                                </template>
                                                                <!--head and cell styles-->

                                                                <template v-slot:cell(tare_weight)="data">
                                                                    <small>{{
                                                                        data.value
                                                                    }} {{ data.item.weight_type }}</small>
                                                                </template>

                                                                <template v-slot:cell(percentage_rate)="data">
                                                                    <small>{{ calcChildPercentRate(data.item) }}%</small>
                                                                </template>

                                                                <template v-slot:cell(appraisal.value)="data">
                                                                    <small>${{ data.value | toFixed2 }}</small>
                                                                </template>

                                                                <!--item details-->
                                                                <template v-slot:cell(details)="data">
                                                                    <template v-if="childHasDetails(data.item.category_id)">
                                                                        <i @click="data.toggleDetails"
                                                                            class="fa-solid text-success"
                                                                            :class="data.detailsShowing ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                                                    </template>
                                                                    <template v-else-if="isMetal(data.item)">
                                                                        {{ data.item.purity }}{{ data.item.purity_type == "kt"
                                                                            ? " " : "" }}{{ data.item.purity_type }}
                                                                    </template>
                                                                    <template v-else>
                                                                        -
                                                                    </template>

                                                                </template>

                                                                <template v-slot:row-details="data">
                                                                    <!--Child Item Details -->
                                                                    <b-row v-if="childHasDetails(data.item.category_id)">
                                                                        <b-col offset="3">
                                                                            <b-table small outlined fixed
                                                                                table-variant="info" thead-tr-class=""
                                                                                tbody-tr-class="" class="font-weight-normal"
                                                                                
                                                                                :fields="childDetailInventoryFields(data.item.category_id)"
                                                                                :items="[data.item]">

                                                                                <!--head and cell styles-->
                                                                                <template v-slot:head()="data">
                                                                                    <small class="">{{
                                                                                        data.label
                                                                                    }}</small>
                                                                                </template>
                                                                                <template v-slot:cell()="data">
                                                                                    <small class="font-xxs"
                                                                                        v-if="data.item.category_id === 2">{{
                                                                                            (data.value || '-')
                                                                                        }}</small>
                                                                                    <small class="font-xxs" v-else>{{
                                                                                        (data.value || '-') | titleCase
                                                                                    }}</small>
                                                                                </template>
                                                                                <!--head and cell styles-->

                                                                                <!--numismatic-->
                                                                                <template
                                                                                    v-slot:cell(numismatic_value)="data">
                                                                                    <small class="font-xxs">${{
                                                                                        data.value | toFixed2
                                                                                    }}</small>
                                                                                </template>

                                                                                <!--certificate name-->
                                                                                <template
                                                                                    v-slot:cell(certificate_name)="data">
                                                                                    <span class="font-xxs">{{ data.value
                                                                                    }}</span>
                                                                                </template>

                                                                                <!--total-->
                                                                                <!--<template-->
                                                                                <!--v-slot:cell(appraisal.total)="data">-->
                                                                                <!--<span-->
                                                                                <!--class="font-xxs">&#45;&#45;&#45;&#45;${{-->
                                                                                <!--data.value | toFixed2-->
                                                                                <!--}}</span>-->
                                                                                <!--</template>-->

                                                                            </b-table>
                                                                        </b-col>
                                                                    </b-row>

                                                                </template>

                                                            </b-table>

                                                        </b-col>
                                                    </b-row>
                                                </b-container>
                                            </template>
                                            <!--quantity-->
                                            <template v-slot:cell(quantity)="data">
                                                <div v-if="data.item.type.item_category_id === 2">
                                                    {{ data.item.children[0].quantity }}
                                                    <small class="font-weight-normal d-block">Coins/Bullion</small>
                                                </div>
                                                <div v-else>
                                                    {{ data.item.quantity }}
                                                </div>
                                            </template>

                                            <!--weight-->
                                            <template v-slot:cell(weight)="data">
                                                {{ data.item.aggregate_dwt }} dwt
                                            </template>
                                        </b-table>
                                        <!--                                                    </b-card>-->
                                    </b-col>
                                </b-row>
                            </template>


                            <template v-slot:cell(items)="data">
                                <strong class="h5">{{ data.item.items }}</strong>
                            </template>


                            <!--purity-->
                            <template v-slot:cell(purity)="data">
                                <strong class="h5">{{ data.item.bag_purity | ucFirst }}
                                    {{ data.item.contains_melee ? 'Melee' : '' }}
                                </strong>
                            </template>

                            <!--bag size-->
                            <template v-slot:cell(bag_size)="data">
                                <b-row no-gutters>
                                    <b-col cols="3"></b-col>
                                    <b-col cols="6">
                                        <b-select v-model="data.item.bag_type_id" :options="bagOptions"
                                            :disabled="data.item.saving" class="font-weight-bold text-center"
                                            @change="changeBagSize(data.item)">
                                        </b-select>
                                        <div class="font-xs text-muted">Bag ID: {{ data.item.bag_id }}</div>
                                    </b-col>
                                </b-row>
                            </template>

                            <!--expected weight-->
                            <template v-slot:cell(expected_weight)="data">

                                <span v-if="data.item.saving == true">
                                    <i class="fa-regular fa-spin fa-spinner"></i>
                                </span>
                                <span v-else>
                                    <div class="font-xxs text-muted">Item: ({{ data.item.item_weight }} dwt) +
                                        Bag: ({{ data.item.material_dwt }} dwt) =
                                    </div>
                                    <strong class="h5">{{ parseFloat(data.item.item_weight) +
                                        parseFloat(data.item.material_dwt) | toFixed2 }} dwt</strong>
                                </span>
                            </template>

                            <!--error-->
                            <template v-slot:cell(error)="data">
                                <b-form-checkbox class="cursor-pointer nice-toggle-error" name="check-button"
                                    v-model="data.item.has_error" @input="setQA('bag', data.item, 'error')" switch
                                    :disabled="working || !_canEdit"></b-form-checkbox>
                            </template>

                            <!--label-->
                            <template v-slot:cell(label)="data">
                                <b-button variant="light" class="cursor-pointer" @click="printLabel('bag', data.item)"
                                    :disabled="working" size="sm">
                                    <i class="fa-regular fa-print"></i>
                                </b-button>
                            </template>

                        </b-table>

                    </b-card>
                </template>
            </b-card>
            <!--end melt-->




            <div class="text-center">
                <LoadingSpinner :busy="loading_items" v-if="loading_items"></LoadingSpinner>
                <div v-else-if="QA.bags.length == 0">
                    no melt inventory exists
                </div>
            </div>


            <!--HELD TABLE-->
            <b-card class="mb-4" header-class="table-header-bg bg-warning-light text-dark" header="Held Items" no-body
                body-class="inventory-table">
                <template v-slot:header>
                    <h4 class="mb-0">Held Items</h4>
                </template>
                <b-table head-variant="dark" ref="hold_items_table" outlined small :items="QA.holds"
                    :fields="held_items.fields" responsive="sm" :busy="loading_items" show-empty
                    emptyText="no held items exist" class="text-center mb-0">
                    <template v-slot:table-busy>
                        <LoadingSpinner :busy="!QA.holds.length > 0" />
                    </template>

                    <template v-slot:head(verified?)="data">
                        Verified?
                        <i v-if="!held_items.selectAll && _canEdit" class="cursor-pointer fa-solid fa-square ml-1"
                            @click="setQA('all-hold', { verified: true }, false, true, () => { held_items.selectAll = !held_items.selectAll });">
                        </i>
                        <i v-if="held_items.selectAll && _canEdit" class="cursor-pointer fa-solid fa-check-square ml-1"
                            @click="setQA('all-hold', { verified: false }, false, true, () => { held_items.selectAll = !held_items.selectAll });">
                        </i>
                    </template>

                    <!--verified-->
                    <template v-slot:cell(id)="data">
                        <b-button variant="link"
                            :to="'/appraisals/appraise/' + $route.params.id + '/inventory/' + data.item.id + '?after_save=QA'">
                            {{ data.value }}
                        </b-button>
                    </template>


                    <!--verified-->
                    <template v-slot:cell(verified?)="data">
                        <b-button :variant="data.item.verified ? 'success' : 'light'" class="cursor-pointer" size="sm"
                            @click="setQA('inventory', data.item, 'verify')" :disabled="working || !_canEdit">
                            <i class="far" :class="data.item.verified ? 'fa-check-square' : 'fa-square'"></i>
                        </b-button>
                    </template>

                    <!--item type-->
                    <template v-slot:cell(class)="data">
                        {{ data.item.class | titleCase }}<span v-if="data.item.purity || data.item.purity_type"> - {{
                            data.item.purity }} {{ data.item.purity_type }}</span>
                    </template>

                    <!--picture-->
                    <template v-slot:cell(picture)="data">
                        <div v-for="(key, value, index1) in QA.inventoryByMetal" :key="index1">
                            <div v-for="(items, index2) in key" :key="index2">
                                <template v-if="data.item.id == items.id">


                                    <div class="pic position-relative pointer" @click="openLightBox(items.media)">
                                        <b-badge pill v-if="items.media.length > 1" variant="primary"
                                            class="position-absolute text-white m-1">
                                            <i class="fa-solid fa-images "></i> {{ items.media.length }}
                                        </b-badge>
                                        <img width="80px" :src="items.media[0] ? items.media[0].url : ''" />
                                    </div>

                                </template>
                            </div>
                        </div>
                    </template>

                    <!--item type-->
                    <template v-slot:cell(item_type)="data">
                        {{ data.item.type_name }}
                        <div class="font-xxs" v-if="data.item.brand_name">Brand: {{ data.item.brand_name }}</div>
                        <div class="font-xs" v-if="data.item.type.item_category_id === 2">
                            Qty: {{ data.item.children[0].quantity }}
                        </div>
                        <template
                            v-if="data.item.children.length > 1 || data.item.type.item_category_id == 13 || data.item.type.item_category_id == 2">
                            <div>
                                <a class="pointer" @click="toggleAllDetails(data)"><small>
                                        <i class="fa-solid text-success"
                                            :class="data.detailsShowing ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                        {{ data.detailsShowing ? 'Hide' : 'Show' }}
                                        Sub Items</small></a>
                            </div>
                        </template>
                    </template>
                    <!-- row details -->
                    <template v-slot:row-details="data">
                        <b-container>
                            <b-row align-h="center">
                                <b-col cols="12" class="p-0">

                                    <!-- Child Items -->
                                    <b-table small outlined fixed bordered thead-tr-class="bg-secondary"
                                        class="font-weight-normal" :fields="[
                                            { key: 'class_name', label: 'type' },
                                            { key: 'tare_weight', label: 'weight' },
                                            'quantity',
                                            { key: 'details', label: 'Details' },]"
                                        :items="data.item.children">
                                        <!--head and cell styles-->
                                        <template v-slot:head()="data">
                                            <small>{{
                                                data.label | titleCase
                                            }}</small>
                                        </template>
                                        <template v-slot:cell()="data">
                                            <small>{{ (data.value || '-') | titleCase }}</small>
                                        </template>
                                        <!--head and cell styles-->

                                        <template v-slot:cell(tare_weight)="data">
                                            <small>{{
                                                data.value
                                            }} {{ data.item.weight_type }}</small>
                                        </template>

                                        <template v-slot:cell(percentage_rate)="data">
                                            <small>{{ calcChildPercentRate(data.item) }}%</small>
                                        </template>

                                        <template v-slot:cell(appraisal.value)="data">
                                            <small>${{ data.value | toFixed2 }}</small>
                                        </template>

                                        <!--item details-->
                                        <template v-slot:cell(details)="data">
                                            <template v-if="childHasDetails(data.item.category_id)">
                                                <i @click="data.toggleDetails" class="fa-solid text-success"
                                                    :class="data.detailsShowing ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                            </template>
                                            <template v-else-if="isMetal(data.item)">
                                                {{ data.item.purity }}{{ data.item.purity_type == "kt" ? " " :
                                                    "" }}{{ data.item.purity_type }}
                                            </template>
                                            <template v-else>
                                                -
                                            </template>

                                        </template>

                                        <template v-slot:row-details="data">
                                            <!--Child Item Details -->
                                            <b-row v-if="childHasDetails(data.item.category_id)">
                                                <b-col offset="3">
                                                    <b-table small outlined fixed table-variant="info" thead-tr-class=""
                                                        tbody-tr-class="" class="font-weight-normal" 
                                                        :fields="childDetailInventoryFields(data.item.category_id)"
                                                        :items="[data.item]">

                                                        <!--head and cell styles-->
                                                        <template v-slot:head()="data">
                                                            <small class="">{{
                                                                data.label
                                                            }}</small>
                                                        </template>
                                                        <template v-slot:cell()="data">
                                                            <small class="font-xxs" v-if="data.item.category_id === 2">{{
                                                                (data.value || '-')
                                                            }}</small>
                                                            <small class="font-xxs" v-else>{{
                                                                (data.value || '-') | titleCase
                                                            }}</small>
                                                        </template>
                                                        <!--head and cell styles-->

                                                        <!--numismatic-->
                                                        <template v-slot:cell(numismatic_value)="data">
                                                            <small class="font-xxs">${{
                                                                data.value | toFixed2
                                                            }}</small>
                                                        </template>

                                                        <!--certificate name-->
                                                        <template v-slot:cell(certificate_name)="data">
                                                            <span class="font-xxs">{{ data.value }}</span>
                                                        </template>

                                                        <!--total-->
                                                        <!--<template-->
                                                        <!--v-slot:cell(appraisal.total)="data">-->
                                                        <!--<span-->
                                                        <!--class="font-xxs">&#45;&#45;&#45;&#45;${{-->
                                                        <!--data.value | toFixed2-->
                                                        <!--}}</span>-->
                                                        <!--</template>-->

                                                    </b-table>
                                                </b-col>
                                            </b-row>

                                        </template>

                                    </b-table>

                                </b-col>
                            </b-row>
                        </b-container>
                    </template>

                    <!--bag size-->
                    <template v-slot:cell(bag_size)="data">
                        <b-row no-gutters>
                            <b-col cols="3"></b-col>
                            <b-col cols="6">
                                <b-select v-model="data.item.bag_type_id" :options="bagOptions" :disabled="data.item.saving"
                                    class="font-weight-bold text-center" @change="changeBagSize(data.item)">
                                </b-select>
                                <div class="font-xs text-muted">Bag ID: {{ data.item.bag_id }}</div>
                            </b-col>
                        </b-row>
                    </template>

                    <!--expected weight-->
                    <template v-slot:cell(expected_weight)="data">
                        <span v-if="data.item.saving == true">
                            <i class="fa-regular fa-spin fa-spinner"></i>
                        </span>
                        <span v-else>
                            <div class="font-xxs text-muted">Item: ({{ data.item.dwt }} dwt) + Bag:
                                ({{ data.item.material_dwt }} dwt) =
                            </div>
                            {{ parseFloat(data.item.dwt) + parseFloat(data.item.material_dwt) | toFixed2 }} dwt
                        </span>
                    </template>


                    <!--error-->
                    <template v-slot:cell(error)="data">
                        <b-form-checkbox class="cursor-pointer nice-toggle-error" name="check-button" switch
                            :checked="data.item.has_error" @change="displayErrorField(data.item)"
                            :id="'error-' + data.item.id" :disabled="working || !_canEdit"></b-form-checkbox>
                        <div v-if="data.item.has_error && seekSelectedType(data.item.error_type)" class="small">
                            {{ seekSelectedType(data.item.error_type) }}
                        </div>
                        <div v-if="data.item.has_error && data.item.description" class="small">
                            {{ data.item.description }}
                        </div>
                        <b-popover title="Describe Error" :target="'error-' + data.item.id"
                            :show.sync="compliance_edits.currentEdit == data.item.id" placement="bottom" triggers="">
                            <b-select :options="compliance_edits.types" v-model="compliance_edits.selected_type"
                                placeholder="Select Error Type" @change="$forceUpdate()">

                            </b-select>
                            <b-select
                                v-if="compliance_edits.subCatagory[String(compliance_edits.selected_type)] != undefined"
                                class="mt-2" placeholder="Select Error-Subtype Type"
                                :options="compliance_edits.subCatagory[String(compliance_edits.selected_type)]"
                                v-model="compliance_edits.subCatagoryText">
                            </b-select>
                            <b-form-input v-else-if="!!(compliance_edits.selected_type)"
                                v-model="compliance_edits.subCatagoryText" placeholder="Enter Description" class="mt-2">

                            </b-form-input>
                            <hr>
                            <div class="">
                                <b-button class="float-right mb-2" variant="success"
                                    @click="saveErrorDescription(data.item)" size="sm">
                                    <i class="fa-solid fa-check fa-fw"></i>
                                    Save
                                </b-button>

                                <b-button class="float-right mb-2 mr-1" @click="cancelErrorField" size="sm">
                                    <i class="fa-solid fa-check fa-times"></i>
                                    Cancel
                                </b-button>
                            </div>
                        </b-popover>
                    </template>

                    <!--label-->
                    <template v-slot:cell(label)="row">
                        <b-button variant="light" class="cursor-pointer" size="sm" @click="printLabel('hold', row.item)"
                            :disabled="working">
                            <i class="fa-regular fa-print"></i>
                        </b-button>
                    </template>

                </b-table>
            </b-card>

            <!--NPM table-->
            <template v-for="(value, name, index) in _getBagsByMetal">

                <b-card class="" header-class="table-header-bg" body-class="p-0" :key="index"
                    :header="name | titleCase" v-if="name == 'other'">
                    <template v-slot:header>
                        <h4 class="mb-0">Non Precious Metals</h4>
                    </template>
                    <b-table :tbody-tr-class="rowClass" class="text-center" head-variant="dark" v-if="!loading_items"
                        :fields="['verified?', 'open_bag', 'purity', 'items', 'bag_size', 'expected_weight', 'error', 'label']"
                        :items="_getBagsByMetal[name]">
                        <!--verified-->
                        <template class="m-4" v-slot:cell(verified?)="data">
                            <b-button :variant="data.item.verified ? 'success' : 'light'" class="cursor-pointer"
                                v-model="data.item.verified" size="sm" @click="setQA('bag', data.item, 'verify')"
                                :disabled="working || !_canEdit">
                                <i class="far" :class="data.item.verified ? 'fa-check-square' : 'fa-square'"></i>
                            </b-button>
                        </template>

                        <!--open-bag-->
                        <template v-slot:cell(open_bag)="row">
                            <b-button variant="light" size="sm" @click="row.toggleDetails" class="cursor-pointer"
                                :disabled="working">
                                <i class="fa-solid text-success"
                                    :class="row.detailsShowing ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                            </b-button>
                        </template>


                        <!--BAG PURITY ITEMS-->
                        <template v-slot:row-details="data">
                            <b-row>
                                <b-col offset="1">
                                    <!--                                                    <b-card border-variant="light" body-class="p-0" class="mb-0">-->
                                    <b-table
                                            small
                                            outlined
                                            thead-class="font-weight-light font-italic text-muted"
                                            class="mb-3 font-xs"
                                            tbody-tr-class="font-weight-normal"
                                            :fields="['id', 'verified?','Error?','Label','Picture','item_details',
                                                                        'quantity','weight']"
                                            :items="_getMeltItems[data.item.bag_id]"
                                            :disabled="working || !_canEdit"
                                    >
                                        <!--id-->
                                        <template v-slot:cell(id)="data">
                                            <b-button variant="link"
                                                    :to="'/appraisals/appraise/'+$route.params.id+'/inventory/'+data.item.id + '?after_save=QA'">
                                                {{ data.value }}
                                            </b-button>
                                        </template>
                                        <!--verified-->
                                        <template v-slot:cell(verified?)="data">
                                            <b-button
                                                    :variant="data.item.verified ? 'success': 'light' "
                                                    class="cursor-pointer"
                                                    @click="setQA('inventory', data.item, 'verify')"
                                                    :disabled="working || !_canEdit" size="sm">
                                                <i class="far"
                                                :class="data.item.verified ? 'fa-check-square': 'fa-square' "></i>
                                            </b-button>
                                        </template>

                                        <!--error?-->
                                        <template v-slot:cell(error?)="data">
                                            <b-form-checkbox class="cursor-pointer nice-toggle-error"
                                                :checked="data.item.has_error" @change="displayErrorField(data.item)"
                                                :id="'error-' + data.item.id" name="check-button" switch
                                                :disabled="working || !_canEdit">
                                            </b-form-checkbox>
                                            <div v-if="data.item.has_error && seekSelectedType(data.item.error_type)"
                                                class="small">
                                                {{ seekSelectedType(data.item.error_type) }}
                                            </div>
                                            <div v-if="data.item.has_error && data.item.description" class="small">
                                                {{ data.item.description }}
                                            </div>
                                            <b-popover title="Describe Error" :target="'error-' + data.item.id"
                                                :show.sync="compliance_edits.currentEdit == data.item.id"
                                                placement="bottom" triggers="">
                                                <b-select :options="compliance_edits.types"
                                                    v-model="compliance_edits.selected_type"
                                                    placeholder="Select Error Type" @change="$forceUpdate()">

                                                </b-select>
                                                <b-select
                                                    v-if="compliance_edits.subCatagory[String(compliance_edits.selected_type)] != undefined"
                                                    class="mt-2" placeholder="Select Error-Subtype Type"
                                                    :options="compliance_edits.subCatagory[String(compliance_edits.selected_type)]"
                                                    v-model="compliance_edits.subCatagoryText">
                                                </b-select>
                                                <b-form-input v-else-if="!!(compliance_edits.selected_type)"
                                                    v-model="compliance_edits.subCatagoryText"
                                                    placeholder="Enter Description" class="mt-2">

                                                </b-form-input>
                                                <hr>
                                                <div class="">
                                                    <b-button class="float-right mb-2" variant="success"
                                                        @click="saveErrorDescription(data.item)" size="sm">
                                                        <i class="fa-solid fa-check fa-fw"></i>
                                                        Save
                                                    </b-button>

                                                    <b-button class="float-right mb-2 mr-1" @click="cancelErrorField"
                                                        size="sm">
                                                        <i class="fa-solid fa-check fa-times"></i>
                                                        Cancel
                                                    </b-button>
                                                </div>
                                            </b-popover>
                                        </template>

                                        <!--label-->
                                        <template v-slot:cell(label)="data">
                                            <b-button variant="light" class="cursor-pointer" :disabled="working"
                                                size="sm" @click="printLabel('item', data.item)">
                                                <i class="fa-regular fa-print"></i>
                                            </b-button>
                                        </template>

                                        <!--picture-->
                                        <template v-slot:cell(picture)="data">
                                            <div class="pic position-relative pointer"
                                                @click="openLightBox(data.item.media)">
                                                <b-badge pill v-if="data.item.media.length > 1" variant="primary"
                                                    class="position-absolute text-white m-1">
                                                    <i class="fa-solid fa-images "></i> {{ data.item.media.length }}
                                                </b-badge>
                                                <img width="80px"
                                                    :src="data.item.media[0] ? data.item.media[0].url : ''" />
                                            </div>

                                        </template>

                                        <!--details-->
                                        <template v-slot:cell(item_details)="data">
                                            {{ data.item.type_name }}
                                            <div class="font-xxs" v-if="data.item.brand_name">Brand: {{
                                                data.item.brand_name }}</div>
                                            <template
                                                v-if="data.item.children.length > 1 || data.item.type.item_category_id == 13 || data.item.type.item_category_id == 2">
                                                <div>
                                                    <a class="pointer" @click="toggleAllDetails(data)"><small>
                                                            <i class="fa-solid text-success"
                                                                :class="data.detailsShowing ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                                            {{ data.detailsShowing ? 'Hide' : 'Show' }}
                                                            Sub Items</small></a>
                                                </div>
                                            </template>
                                        </template>
                                        <!-- row details -->
                                        <template v-slot:row-details="data">
                                            <b-container>
                                                <b-row align-h="center">
                                                    <b-col cols="12" class="p-0">

                                                        <!-- Child Items -->
                                                        <b-table small outlined fixed bordered
                                                            thead-tr-class="bg-secondary"
                                                            class="font-weight-normal"
                                                            :fields="[
                                                                { key: 'class_name', label: 'type' },
                                                                { key: 'tare_weight', label: 'weight' },
                                                                'quantity',
                                                                { key: 'details', label: 'Details' },
                                                            ]" :items="data.item.children">
                                                            <!--head and cell styles-->
                                                            <template v-slot:head()="data">
                                                                <small>{{
                                                                    data.label | titleCase
                                                                }}</small>
                                                            </template>
                                                            <template v-slot:cell()="data">
                                                                <small>{{ (data.value || '-') | titleCase }}</small>
                                                            </template>
                                                            <!--head and cell styles-->

                                                            <template v-slot:cell(tare_weight)="data">
                                                                <small>{{
                                                                    data.value
                                                                }} {{ data.item.weight_type }}</small>
                                                            </template>

                                                            <template v-slot:cell(percentage_rate)="data">
                                                                <small>{{ calcChildPercentRate(data.item) }}%</small>
                                                            </template>

                                                            <template v-slot:cell(appraisal.value)="data">
                                                                <small>${{ data.value | toFixed2 }}</small>
                                                            </template>

                                                            <!--item details-->
                                                            <template v-slot:cell(details)="data">
                                                                <template v-if="childHasDetails(data.item.category_id)">
                                                                    <i @click="data.toggleDetails"
                                                                        class="fa-solid text-success"
                                                                        :class="data.detailsShowing ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                                                </template>
                                                                <template v-else-if="isMetal(data.item)">
                                                                    {{ data.item.purity }}{{ data.item.purity_type == "kt"
                                                                        ? " " : "" }}{{ data.item.purity_type }}
                                                                </template>
                                                                <template v-else>
                                                                    -
                                                                </template>

                                                            </template>

                                                            <template v-slot:row-details="data">
                                                                <!--Child Item Details -->
                                                                <b-row v-if="childHasDetails(data.item.category_id)">
                                                                    <b-col offset="3">
                                                                        <b-table small outlined fixed
                                                                            table-variant="info" thead-tr-class=""
                                                                            tbody-tr-class="" class="font-weight-normal"
                                                                            :key="index"
                                                                            :fields="childDetailInventoryFields(data.item.category_id)"
                                                                            :items="[data.item]">

                                                                            <!--head and cell styles-->
                                                                            <template v-slot:head()="data">
                                                                                <small class="">{{
                                                                                    data.label
                                                                                }}</small>
                                                                            </template>
                                                                            <template v-slot:cell()="data">
                                                                                <small class="font-xxs"
                                                                                    v-if="data.item.category_id === 2">{{
                                                                                        (data.value || '-')
                                                                                    }}</small>
                                                                                <small class="font-xxs" v-else>{{
                                                                                    (data.value || '-') | titleCase
                                                                                }}</small>
                                                                            </template>
                                                                            <!--head and cell styles-->

                                                                            <!--numismatic-->
                                                                            <template
                                                                                v-slot:cell(numismatic_value)="data">
                                                                                <small class="font-xxs">${{
                                                                                    data.value | toFixed2
                                                                                }}</small>
                                                                            </template>

                                                                            <!--certificate name-->
                                                                            <template
                                                                                v-slot:cell(certificate_name)="data">
                                                                                <span class="font-xxs">{{ data.value
                                                                                }}</span>
                                                                            </template>

                                                                            <!--total-->
                                                                            <!--<template-->
                                                                            <!--v-slot:cell(appraisal.total)="data">-->
                                                                            <!--<span-->
                                                                            <!--class="font-xxs">&#45;&#45;&#45;&#45;${{-->
                                                                            <!--data.value | toFixed2-->
                                                                            <!--}}</span>-->
                                                                            <!--</template>-->

                                                                        </b-table>
                                                                    </b-col>
                                                                </b-row>

                                                            </template>

                                                        </b-table>

                                                    </b-col>
                                                </b-row>
                                            </b-container>
                                        </template>
                                        <!--quantity-->
                                        <template v-slot:cell(quantity)="data">
                                            <div v-if="data.item.type.item_category_id === 2">
                                                {{ data.item.children[0].quantity }}
                                                <small class="font-weight-normal d-block">Coins/Bullion</small>
                                            </div>
                                            <div v-else>
                                                {{ data.item.quantity }}
                                            </div>
                                        </template>

                                        <!--weight-->
                                        <template v-slot:cell(weight)="data">
                                            {{ data.item.aggregate_dwt }} dwt
                                        </template>
                                    </b-table>
                                    <!--                                                    </b-card>-->
                                </b-col>
                            </b-row>
                        </template>


                        <template v-slot:cell(items)="data">
                            <strong class="h5">{{ data.item.items }}</strong>
                        </template>


                        <!--purity-->
                        <template v-slot:cell(purity)="data">
                            <strong class="h5">{{ data.item.bag_purity | ucFirst }}
                                {{ data.item.contains_melee ? 'Melee' : '' }}
                            </strong>
                        </template>

                        <!--bag size-->
                        <template v-slot:cell(bag_size)="data">
                            <b-row no-gutters>
                                <b-col cols="3"></b-col>
                                <b-col cols="6">
                                    <b-select v-model="data.item.bag_type_id" :options="bagOptions"
                                        :disabled="data.item.saving" class="font-weight-bold text-center"
                                        @change="changeBagSize(data.item)">
                                    </b-select>
                                    <div class="font-xs text-muted">Bag ID: {{ data.item.bag_id }}</div>
                                </b-col>
                            </b-row>
                        </template>

                        <!--expected weight-->
                        <template v-slot:cell(expected_weight)="data">

                            <span v-if="data.item.saving == true">
                                <i class="fa-regular fa-spin fa-spinner"></i>
                            </span>
                            <span v-else>
                                <div class="font-xxs text-muted">Item: ({{ data.item.item_weight }} dwt) +
                                    Bag: ({{ data.item.material_dwt }} dwt) =
                                </div>
                                <strong class="h5">{{ parseFloat(data.item.item_weight) +
                                    parseFloat(data.item.material_dwt) | toFixed2 }} dwt</strong>
                            </span>
                        </template>

                        <!--error-->
                        <template v-slot:cell(error)="data">
                            <b-form-checkbox class="cursor-pointer nice-toggle-error" name="check-button"
                                v-model="data.item.has_error" @input="setQA('bag', data.item, 'error')" switch
                                :disabled="working || !_canEdit"></b-form-checkbox>
                        </template>

                        <!--label-->
                        <template v-slot:cell(label)="data">
                            <b-button variant="light" class="cursor-pointer" @click="printLabel('bag', data.item)"
                                :disabled="working" size="sm">
                                <i class="fa-regular fa-print"></i>
                            </b-button>
                        </template>

                    </b-table>

                </b-card>
            </template>
            <!--end NPM-->

            <!--footer btns-->
            <div class="text-right">
                <b-button size="lg" variant="info" :disabled="working || (!readyForOfferGen && _canEdit)" @click="scanNew">
                    <i class="fa-solid fa-barcode-scan"></i> Scan New Order
                </b-button>
                <b-button size="lg" variant="danger" class="ml-2" :disabled="working || !_canEdit"
                    :to="'/appraisals/appraise/' + $route.params.id + '?after_save=QA'">
                    <i class="fa-solid fa-undo"></i> Return To Appraisal
                </b-button>
                <b-button size="lg" variant="warning" class="ml-2 text-white" :disabled="working || !_canEdit"
                    @click="setToInventoryHold">
                    <i class="fa-solid fa-hand-paper"></i> Move to Appraisal Hold
                </b-button>
                <b-button size="lg" variant="info" class="ml-2" :disabled="working || !readyForOfferGen || !_canEdit"
                    @click="setToOfferGen">
                    <i class="fa-solid fa-arrow-right"></i> Continue to Offer Generation
                </b-button>
            </div>
        </b-card>

        <NotesPopup :order_id="!order ? null : order.id" :customer_id="order.customer.id"
            style="z-index: 1000">
        </NotesPopup>

    </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner';
import _ from 'lodash';
import GenericPopups from '../../components/GenericPopups';
import moment from 'moment';
import OrderCardHeader from '@/components/OrderCardHeader';
import PhotoWidget from '../../components/PhotoWidget';
import WeightValidation from '@/components/WeightValidation';
import Multiselect from 'vue-multiselect';
import ImageLightBox from '@/components/ImageLightBox';
import NotesPopup from '../../components/NotesPopup';

export default {
    name: 'quality-assurance-view',
    components: {
        OrderCardHeader,
        LoadingSpinner,
        GenericPopups,
        Multiselect,
        PhotoWidget: PhotoWidget,
        WeightValidation: WeightValidation,
        ImageLightBox,
        NotesPopup
    },
    created() {
        this.getData();
        //this.getQA();
        //this.getCustomer();
    },
    mounted() {
        this.$barcodeScanner.init((rawBarcode) => {
            this.$barcodeScanner.parseBarcode(rawBarcode, (barcode) => {
                this.$bvToast.toast('Scanned barcode "' + barcode + '"', {
                title: 'Barcode Scanner',
                appendToast: true,
                autoHideDelay: 3000,
            });
            let bag = _.find(this.QA.bags, ['bag_id', parseInt(barcode)]);
            if (bag) {
                console.log(bag, this.scaleWeight);
                let expectedWeight = _.round(parseFloat(bag.material_dwt) + parseFloat(bag.item_weight), 2);
                console.log(expectedWeight);
                if (_.round(parseFloat(this.scaleWeight), 2) <= expectedWeight + 0.4 && _.round(parseFloat(this.scaleWeight), 2) >= expectedWeight - 0.4) {
                    this.setQA('bag', bag, 'verify', false);
                } else {
                    this.$bvToast.toast('Weight does not match.', {
                        title: 'Barcode Scanner',
                        variant: 'danger',
                        appendToast: true,
                        autoHideDelay: 3000,
                    });
                }
            } else {
                let hold_item = _.find(this.QA.holds, ['id', parseInt(barcode)]);
                if (hold_item) {
                    let expectedWeight = _.round(parseFloat(hold_item.material_dwt) + parseFloat(hold_item.dwt), 2);
                        if (this.$refs.WeightValidation.validateQAWeight(parseFloat(this.scaleWeight), expectedWeight)) {
                            this.setQA('inventory', hold_item, 'verify', false);
                        } else {
                            this.$bvToast.toast('Weight does not match.', {
                                title: 'Barcode Scanner',
                                variant: 'danger',
                                appendToast: true,
                                autoHideDelay: 3000,
                            });
                        }
                    } else {
                        this.$bvToast.toast('No match found.', {
                            title: 'Barcode Scanner',
                            variant: 'warning',
                            appendToast: true,
                            autoHideDelay: 3000,
                        });
                    }
                }
            })
                ;
        })
            ;
    },
    beforeDestroy() {
        this.$barcodeScanner.destroy();
    },
    data() {
        return {
            readyForOfferGen: false,
            loading_items: false,
            loading: false,
            working: false,
            saving: false,
            savingStatus: null,
            activeItem: false,
            scaleStable: false,
            scaleWeight: null,
            scaleSaved: false,
            scaleVarianceError: false,
            number: 3,
            order: null,
            bags: null,
            bagOptions: [
                { value: null, text: 'Please select an option', disabled: true, },
                { value: 1, text: 'Small Bag' },
                { value: 2, text: 'Medium Bag' },
                { value: 3, text: 'Large Bag' },
                { value: 4, text: 'X-Large Bag' }
            ],
            QA: {
                bags: [],
                holds: [],
                inventoryByMetal: {},
            },
            cachedOrderData: null,
            compliance: {
                allVerified: false,
                signature_card: {
                    isEditing: false,
                    isSaved: false,
                    verified: false,
                    error: false,
                    isSaving: true,
                    error_description: null,
                    error_options: [
                        { value: null, text: 'Choose Description', disabled: true },
                        { value: 'Card incorrectly marked as present', text: 'Card incorrectly marked as present' },
                        { value: 'Card incorrectly marked as not present', text: 'Card incorrectly marked as not present' },
                        { value: 'Card present but missing pictures', text: 'Card present but missing pictures' },
                    ],
                },
                signature: {
                    isEditing: false,
                    isSaved: false,
                    verified: false,
                    error: false,
                    isSaving: true,
                    error_description: null,
                    error_options: [
                        { value: null, text: 'Choose Description', disabled: true },
                        { value: 'Incorrect signature option selected', text: 'Incorrect signature option selected' },
                    ],
                },
                identification: {
                    isEditing: false,
                    isSaved: false,
                    isSaving: true,
                    verified: false,
                    error: false,
                    error_description: null,
                    error_options: [
                        { value: null, text: 'Choose Description', disabled: true },
                        { value: 'Incorrect type', text: 'Incorrect Type' },
                        { value: 'Incorrect state', text: 'Incorrect State' },
                        { value: 'Incorrect number', text: 'Incorrect Number' },
                        { value: 'Incorrect expiration', text: 'Incorrect Expiration' },
                    ],
                },
                payment: {
                    isEditing: false,
                    isSaved: false,
                    isSaving: true,
                    verified: false,
                    error: false,
                    error_description: null,
                    error_options: [
                        { value: null, text: 'Choose Description', disabled: true },
                        {
                            value: 'Incorrect payment option was selected',
                            text: 'Incorrect payment option was selected'
                        },
                        { value: 'Incorrect payment entry', text: 'Incorrect payment entry' },
                    ],
                },
                dob: {
                    isEditing: false,
                    isSaved: false,
                    isSaving: true,
                    verified: false,
                    error: false,
                    error_description: null,
                    error_options: [
                        { value: null, text: 'Choose Description', disabled: true },
                        { value: 'DOB-INCORRECT', text: 'Incorrect birthday entered' },
                    ],
                },
                bonus_card: {
                    isEditing: false,
                    isSaved: false,
                    verified: false,
                    error: false,
                    isSaving: true,
                    error_description: null,
                    error_options: [
                        { value: null, text: 'Choose Description', disabled: true },
                        { value: 'Bonus Card incorrectly marked as present', text: 'Bonus Card incorrectly marked as present' },
                        { value: 'Bonus Card incorrectly marked as not present', text: 'Bonus Card incorrectly marked as not present' },
                    ],
                },
                ssn_last_4: {
                    isEditing: false,
                    isSaved: false,
                    isSaving: true,
                    verified: false,
                    error: false,
                    error_description: null,
                    error_options: [
                        { value: null, text: 'Choose Description', disabled: true },
                        { value: 'Incorrect SSN entry', text: 'Incorrect SSN entry' },
                    ],
                },
            },
            compliance_edits: {

                currentEdit: null,
                selected_type: 0,
                types: [
                    { text: 'Metal/Purity', value: 8 },
                    { text: 'Picture', value: 9 },
                    { text: 'Video', value: 10 },
                    { text: 'Weight', value: 11 },
                    { text: 'Quantity', value: 12 },
                    { text: 'Color', value: 13 },
                    { text: 'Brand/Style', value: 14 },
                    { text: 'Engraving/Serial', value: 15 },
                    { text: 'Condition', value: 16 },
                    { text: 'Length/Size', value: 17 },
                    { text: 'Melt/Hold', value: 18 },
                    { text: 'Testing', value: 19 },
                    { text: 'Additions/Subtractions', value: 20 },
                    { text: 'Description/Notes', value: 21 },
                    { text: 'Mis-bagged', value: 22 },
                    { text: 'Other', value: 23 },
                ],
                subCatagoryText: '',
                subCatagory: {
                    '8': [ //Metal/Purity
                        'Metal wrong',
                        'Purity wrong',
                    ],
                    '9': [ //Picture
                        'Picture Blurry',
                        'Wrong Picture',
                        'Picture Missing',
                    ],
                    '10': [ //Video
                        'Video Blurry',
                        'Wrong Video',
                        'Video missing',
                    ],
                    '11': [ //Weight
                        'Wrong weight'
                    ],
                    '12': [ // Quantity
                        'Wrong quantity'
                    ],
                    '13': [ //Color
                        'Wrong Color'
                    ],
                    '14': [ //Brand/Style
                        'Wrong Brand',
                        'Wrong Style'
                    ],
                    '15': [ // Engraving/Serial number
                        'Wrong engraving/serial number',
                        'Missing engraving/serial number'
                    ],
                    '16': [ //Condition
                        'Condition missing',
                        'Wrong Condition'
                    ],
                    '17': [ //Length/Size
                        'Wrong Length/Size',
                        'Missing Length/Size',
                    ],
                    '18': [ //Melt/Hold
                        'Item should be melted',
                        'Item should be on hold',
                    ],
                    '19': [ //Testing
                        'Didn’t test',
                        'Results incorrect',
                    ],
                    '20': [ //Additions/Subtractions
                        'Addition wrong',
                        'Addition missing',
                        'Subtraction wrong',
                        'Subtraction missing',
                    ],
                    '21': [ //Description/Notes
                        'Description/Notes incorrect'
                    ],
                    '22': [ //Mis-bagged
                        'Wrong Bag'
                    ],
                }
            },
            bag_inventory: {
                fields: ['verified?', 'open_bag', 'purity', 'items', 'bag_size', 'expected_weight', 'error', 'label'],
                selected: [],
                selectAll: false,
            },
            held_items: {
                fields: ['id', 'verified?', 'class', 'picture', 'item_type', 'bag_size', 'expected_weight', 'error', 'label'],
                selected: [],
                selectAll: false,
            }
        };
    },


    computed: {
        _canViewMaskedData() {
            let roles = this.$store.state.user.profile.roles.data;
            let hasRole = roles.some(role => (role.name === 'Operations Admin' || role.name === 'Processing Admin' || role.name == 'Processing Diamond Appraiser' || role.name == 'Compliance Admin'));
            return hasRole;
        },
        _state: {
            get() {
                let search = _.filter(this.US_STATES_LIST_UNFILTERED[0].types, (e) => {
                    return this.order.customer.identity_state == e.id;
                });
                if (search && search[0]) {
                    return search[0];
                }
                return null;
            },
            set(value) {
                if (value) {
                    this.order.customer.identity_state = value.id;
                }
                else {
                    this.order.customer.identity_state = null;
                }
            }
        },
        // create bags with nested inventory items
        _getMeltItems() {
            let obj = {};
            let inventory = this.QA.inventoryByMetal;
            Object.keys(inventory).forEach(function (key) {
                inventory[key].forEach(function (item) {
                    if (item.status_name !== 'hold') {
                        if (!(item.bag_id in obj)) {
                            obj[item.bag_id] = [];
                        }
                        obj[item.bag_id].push(item);
                    }
                });
            });
            return obj;
        },

        // Add weight and item totals of melt items by metal type
        _getMeltItemsSummary() {
            let that = this;
            let totals = {};
            Object.keys(this._getBagsByMetal).forEach(function (key) {
                let items = that._getBagsByMetal[key].reduce((acc, item) => acc + item.items, 0
                )
                    ;
                let weight = that._getBagsByMetal[key].reduce((acc, item) => parseFloat(acc) + parseFloat(item.item_weight), 0
                )
                    ;
                totals[key] = {
                    items: items,
                    weight: _.round(weight, 2),
                };
            });
            return totals;
        },

        // organize QA Melt bags by metal type
        _getBagsByMetal() {
            let finalSortedBags = {};
            let presortedBags = {
                'gold': [],
                'silver': [],
                'platinum': [],
                'palladium': [],
                'gold-filled': [],
                'other': [],
            };
            this.QA.bags.forEach(function (bag) {
                if (bag.class in presortedBags) {
                    presortedBags[bag.class].push(bag);
                } else {
                    presortedBags[bag.class] = [];
                    presortedBags[bag.class].push(bag);
                }
            });
            _.forEach(presortedBags, (bag, key) => {
                if (bag.length > 0) {
                    bag = _.orderBy(bag, [function (o) {
                    return parseFloat(o.purity);
                }], ['desc']);
                    finalSortedBags[key] = bag;
                }
            });
            return finalSortedBags;
        },

        _canEdit() {
            return !(this.order.status_id === 8
                || this.order.status_id === 9
                || this.order.status_id === 10
                || this.order.status_id === 11
                || this.order.status_id === 12
                || this.order.status_id === 13
                || this.order.status_id === 14
                || this.order.status_id === 15);
        },
        _canEditBonus() {
            return !(_.filter(this.flags,function(e){
                    return e.flag_type.id == 14 && e.cleared_at == null;
            }).length > 0 || parseFloat(this.order.offer_quote > 0));
        },
        _isFlagUpdated() {
            return this.$store.getters.updatedFlag;
        }
    },
    methods: {
        openLightBox(media) {
            this.$refs.ImageLightBox.showLightBox(media);
        },
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        getValidationComplaint({ errors = [] }) {
            if (errors.length > 0) {
                return errors[0];
            }
            return '';
        },
        isMetal: function (itemComponent) {
            if (itemComponent && itemComponent.category_id !== null) {
                let category_id = itemComponent.category_id;
                return category_id !== 7 && category_id !== 13 && category_id !== 8 && category_id !== 9 && category_id !== 12 && category_id !== 11;
            }
            return false;
        },
        toggleAllDetails(data) {
            data.toggleDetails();
            data.item.children.forEach((child) => {
                this.$set(child, '_showDetails', true);
            });
        },
        childHasDetails(categoryID) {
            let showDetails;
            switch (categoryID) {
                case 2:
                case 7:
                case 8:
                case 9:
                case 13:
                    showDetails = true;
                    break;
                default:
                    showDetails = false;
            }
            return showDetails;
        },
        childDetailInventoryFields(categoryID) {
            let fields;
            switch (categoryID) {
                case 2:
                    //                      // coins
                    fields = [
                        { key: 'type_name', label: 'Region' },
                        { key: 'style_name', label: 'Coin Type' },
                        { key: 'quantity', label: 'Quantity' },
                        { key: 'numismatic_value', label: 'EAV' },
                    ];
                    break;
                //
                case 13:
                case 7:
                    // Diamonds/Melee & precious stones
                    fields = [
                        { key: 'style_name', label: 'Cut' },
                        { key: 'color_name', label: 'Color' },
                        { key: 'clarity_name', label: 'Clarity' },
                        { key: 'numismatic_value', label: 'EAV' },
                        { key: 'certificate_name', label: 'Certificate Type' },
                        { key: 'certificate_number', label: 'Certificate Number' },
                        { key: 'condition_name', label: 'Condition' },
                    ];
                    break;
                case 8:
                case 9:
                    // Gem/Synthetic
                    fields = [
                        { key: 'type_name', label: 'Item Type' },
                        { key: 'style_name', label: 'Style' },
                    ];
                    break;
            }
            return fields;
        },
        changeBagSize(item) {
            item.saving = true;
            this.$forceUpdate();
            this.$http.put('/bags/' + item.bag_id, {
                bag_type_id: item.bag_type_id,
                class: item.class,
                purity: item.purity
            }).then((response) => {
                item.saving = false;
                let bag = _.find(this.bags, ['id', item.bag_id]);
                this.$set(bag, 'bagType', response.data.data.bagType);
                this.$set(bag, 'material_dwt', response.data.data.bagType.bag_dwt);
                this.$set(bag, 'bag_type_id', response.data.data.bagType.id);
                this.$set(item, 'bag_type', response.data.data.bagType.name);

                if (item.isHold) {
                    this.printLabel('hold', item);
                } else {
                    console.log(item);
                    this.printLabel('bag', item);
                }
            });
        },
        rowClass(item, type) {
            if (item._showDetails && type == 'row') {
                return 'table-secondary';
            }
        },
        getFlagsByType(type) {
            return _.filter(this.order.flags, (e) => { return e.flag_type.id == type && e.cleared_at == null; });
        },
        activateImageModal(item) {
            var img = item.url;
            this.$refs.PhotoWidget.renderImage(img);
        },
        displayErrorField(item) {
            item.has_error = !item.has_error;
            if (item.has_error) {
                this.compliance_edits.currentEdit = item.id;
            }
            else {
                this.compliance_edits.currentEdit = null;
            }
            this.compliance_edits.selected_type = item.subtype;
            this.compliance_edits.subCatagoryText = item.description;
            //save it.
            this.setQA('inventory', item, 'error', true);
        },
        seekSelectedType(value) {
            console.log(value);
            let res = _.find(this.compliance_edits.types, function (e) { console.log('inside', e); return e.value == value; });
            console.log(res);
            return res ? res.text : null;
        },
        cancelErrorField() {
            this.compliance_edits.currentEdit = null;
        },
        saveErrorDescription(item) {
            this.compliance_edits.currentEdit = null;
            item.error_type = this.compliance_edits.selected_type;
            item.description = this.compliance_edits.subCatagoryText;
            this.setQA('inventory', item, 'error', true);
        },
        getData() {
            this.loading_items = true;
            this.loading = true;
            this.working = true;
            this.scaleStable = false;
            this.scaleWeight = null;
            this.scaleSaving = false;
            this.scaleSaved = false;
            this.order = null;

            this.$http.get('/orders/' + this.$route.params.id + '/bags')
                .then((response) => {
                    // TODO: Map response to QA obj
                    //'{"bag_id":9000403,"bag_purity":"gold 22.00K","bag_type_id":18,"bag_type":"Medium","metal":"gold","purity":22,"purity_type":"kt","material_dwt":1.4,"items":1,"item_weight":34,"item_ids":9000387,"printing":0},'
                    //'{"id":9000410,"hold_bag_type":18,"bag_name":"Medium Bag","default_material_dwt":1.4,"item_type_id":4,"item_type":"Coin","metal":"silver","purity":99.99,"purity_type":"%","dwt":34,"printing":0}'
                    let bags = response.data.data;
                    this.bags = bags;
                    if (!this.$route.params.id) {
                        //issue when returning to previous page due to param id no longer being valid, TODO, fix loading order.
                        return;
                    }
                    this.$http.get('/qa/' + this.$route.params.id).then((response) => {
                        let QA = response.data.data;
                        bags.forEach((bag) => {
                            if (bag.inventory.length > 0
                            ) { //valid bags only (issue detected/found due to editing inventory)
                                if (bag.bag_contents_status !== 'melt') {
                                    let qaElements = _.filter(QA, (e) => {
                                        return e.inventory_id == bag.inventory[0].id;
                                    })
                                        ;
                                    let qaElement = {
                                        verified: false,
                                        has_error: false,
                                        subtype: false,
                                        description: false,
                                    };
                                    if (qaElements.length > 0) {
                                        qaElement = qaElements[0];
                                    }
                                    bag.inventory[0].children.forEach((a) => {
                                        this.$set(a, '_showDetails', true);
                                    });
                                    this.QA.holds.push({
                                        id: bag.held_inventory_item_id,
                                        type: bag.inventory[0].type,
                                        type_name: bag.inventory[0].type_name,
                                        bag_purity: bag.class + ' ' + bag.purity + ' ' + bag.purity_type,
                                        bag_type_id: bag.bag_type_id,
                                        bag_id: bag.id,
                                        brand_name: bag.inventory[0].brand_name,
                                        children: bag.inventory[0].children,
                                        bag_type: bag.bagType.name,
                                        class: bag.class,
                                        purity: bag.purity,
                                        purity_type: bag.purity_type,
                                        material_dwt: bag.bagType.bag_dwt,
                                        //items: bag.inventory.length,
                                        aggregate_dwt: bag.inventory[0].aggregate_dwt,
                                        dwt: bag.inventory[0].aggregate_dwt,
                                        printing: false,
                                        verified: qaElement.is_verified,
                                        has_error: qaElement.is_error,
                                        error_type: qaElement.subtype,
                                        description: qaElement.description,
                                        _showDetails: false,
                                        saving: false,
                                        isHold: true,

                                    });
                                } else {
                                    let qaElements = _.filter(QA, (e) => {
                                        return e.bag_id == bag.id;
                                    })
                                        ;
                                    let qaElement = {
                                        verified: false,
                                        has_error: false,
                                        subtype: false,
                                        description: false,
                                    };
                                    if (qaElements.length > 0) {
                                        qaElement = qaElements[0];
                                    }
                                    let purity = bag.purity ? bag.purity : '';
                                    let purity_type = bag.purity_type ? bag.purity_type : '';
                                    this.QA.bags.push({
                                        bag_id: bag.id,
                                        bag_purity: bag.class + ' ' + purity + ' ' + purity_type,
                                        contains_melee: bag.contains_melee,
                                        bag_type_id: bag.bag_type_id,
                                        bag_type: bag.bagType.name,
                                        class: bag.class,
                                        purity: bag.purity,
                                        purity_type: bag.purity_type,
                                        material_dwt: bag.bagType.bag_dwt,
                                        items: bag.inventory.length,
                                        item_weight: bag.dwt,
                                        printing: false,
                                        verified: qaElement.is_verified,
                                        has_error: qaElement.is_error,
                                        error_type: qaElement.subtype,
                                        description: qaElement.description,
                                        _showDetails: true,
                                        saving: false,
                                        isHold: false
                                    });
                                }
                            }
                            // Build array of inventory by metal type
                            bag.inventory.forEach((item) => {
                                item.verified = false;
                                item.error = false;
                                item.error_type = null;
                                this.$set(item, '_showDetails', false);
                                item.children.forEach((a) => {
                                    this.$set(a, '_showDetails', true);
                                });
                                let qaElements = _.filter(QA, (e) => {
                                    return e.inventory_id == item.id;
                                })
                                    ;
                                let qaElement = {
                                    verified: false,
                                    has_error: false,
                                    error_type: false,
                                    subtype: false,
                                    description: false,
                                };
                                if (qaElements.length > 0) {
                                    qaElement = qaElements[0];
                                }
                                item.verified = qaElement.is_verified;
                                item.has_error = qaElement.is_error;
                                item.error_type = qaElement.subtype;
                                item.description = qaElement.description;
                                if (!this.QA.inventoryByMetal[bag.class]) {
                                    this.$set(this.QA.inventoryByMetal, bag.class, []);
                                }
                                this.QA.inventoryByMetal[bag.class].push(item);
                            })
                                ;
                        })
                            ;
                        //assign top compliance
                        _.forEach(QA,
                            (e) => {
                                switch (e.qa_type_id
                                ) {
                                    case
                                        1
                                        ://card
                                        this.compliance.signature_card.error = e.is_error ? true : false;
                                        this.compliance.signature_card.verified = e.is_verified ? true : false;
                                        this.compliance.signature_card.error_description = e.description;
                                        break;
                                    case
                                        2
                                        ://signature
                                        this.compliance.signature.error = e.is_error ? true : false;
                                        this.compliance.signature.verified = e.is_verified ? true : false;
                                        this.compliance.signature.error_description = e.description;
                                        break;
                                    case
                                        3
                                        ://identification
                                        this.compliance.identification.error = e.is_error ? true : false;
                                        this.compliance.identification.verified = e.is_verified ? true : false;
                                        this.compliance.identification.error_description = e.description;
                                        break;
                                    case
                                        4
                                        ://payments
                                        this.compliance.payment.error = e.is_error ? true : false;
                                        this.compliance.payment.verified = e.is_verified ? true : false;
                                        this.compliance.payment.error_description = e.description;
                                        break;
                                    case
                                        24
                                        : //dob
                                        this.compliance.dob.error = e.is_error ? true : false;
                                        this.compliance.dob.verified = e.is_verified ? true : false;
                                        this.compliance.dob.error_description = e.description;
                                        break;
                                    case
                                        25
                                        ://bonus card
                                        this.compliance.bonus_card.error = e.is_error ? true : false;
                                        this.compliance.bonus_card.verified = e.is_verified ? true : false;
                                        this.compliance.bonus_card.error_description = e.description;
                                        break;
                                    case
                                        26
                                        ://ssn last 4
                                        this.compliance.ssn_last_4.error = e.is_error ? true : false;
                                        this.compliance.ssn_last_4.verified = e.is_verified ? true : false;
                                        this.compliance.ssn_last_4.error_description = e.description;
                                        break;
                                }
                            }
                        )
                            ;
                        this.$forceUpdate();
                        this.$nextTick(() => {
                            this.loading_items = false;
                        })
                            ;
                        let data = ['signature', 'signature_card', 'identification', 'dob', 'payment', 'bonus_card', 'ssn_last_4',];
                        data.forEach((dataItem) => {
                            this.compliance[dataItem].isSaving = false;
                        })
                            ;
                        this.checkreadyForOfferGen();
                    });
                    this.$parent.$forceUpdate();
                });

            this.$http.get('/orders/' + this.$route.params.id + '?append=bonus_information')
                .then(response => {
                    this.order = response.data.data;
                    if (!(this.order.status_name === 'Appraisal Hold'
                        || this.order.status_name === 'Quality Assurance'
                        || this.order.status_name === 'Offer Generation'
                        || this.order.status_name === 'Offer Ready'
                        || this.order.status_name === 'Offer Accepted'
                        || this.order.status_name === 'Offer Declined'
                        || this.order.status_name === 'Reverse Ship'
                        || this.order.status_name === 'Settled'
                        || this.order.status_name === 'Returned')) {
                        this.$parent.$bvModal.msgBoxOk('Order must be in Quality Assurance or Appraisal Hold Status.', {
                            title: 'Invalid Status',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                        this.$router.push('/quality-assurance');
                    }
                    this.cachedOrderData = Object.assign({}, this.order);
                    this.$store.commit('setActiveOrder', this.order);

                    // skip first change in data
                    this.$nextTick(() => {
                        this.loading = false;
                        this.working = false;
                    });
                })
                .catch(() => {
                    this.$router.replace({ path: '/quality-assurance/not-found/' + this.$route.params.id });
                });
            /*FOR GETTING QA**/
        },
        consolelog(data) {
            console.log('displayelog', data);
            return data;
        },
        // saves data edits
        saveEdits(e) {
            let key = e.target.attributes['data-editing'].value;
            let that = this;
            this.cachedOrderData = Object.assign({}, this.order);
            this.compliance[key].isSaving = true;
            this.compliance[key].isSaved = false;

            console.log(key);

            // Save edited information
            if (key === 'signature_card') {
                this.$http.put('/orders/' + this.order.id, {
                    card_present: this.order.card_present
                }).then(response => {
                    console.log(response);
                    that.compliance[key].isSaved = true;
                    that.compliance[key].isSaving = false;
                    that.compliance[key].isEditing = false;
                    setTimeout(() => {
                        that.compliance[key].isSaved = false;
                    },
                        1500
                    )
                        ;
                }).catch(() => { that.compliance[key].isSaving = false; })
                    ;
            }
            if (key === 'signature') {
                this.$http.put('/orders/' + this.order.id, {
                    card_signed: this.order.card_signed
                }).then(response => {
                    console.log(response);
                    that.compliance[key].isSaved = true;
                    that.compliance[key].isSaving = false;
                    that.compliance[key].isEditing = false;
                    setTimeout(() => {
                        that.compliance[key].isSaved = false;
                    },
                        1500
                    )
                        ;
                }).catch(() => { that.compliance[key].isSaving = false; })
                    ;
            }
            // TODO: wrap all ajax calls in promise to handle saving cleanup once
            if (key === 'identification') {
                this.$http.put('/customers/' + this.order.customer.id, {
                    identity_type: this.order.customer.identity_type,
                    identity_number: this.order.customer.identity_number,
                    identity_state: this.order.customer.identity_state,
                    identity_country: this.order.customer.identity_country,
                    identity_expiration: this.order.customer.identity_expiration,
                }).then(response => {
                    console.log(response);
                    that.order.customer.identity_number_masked = response.data.data.identity_number_masked;
                    that.compliance[key].isSaved = true;
                    that.compliance[key].isSaving = false;
                    that.compliance[key].isEditing = false;
                    setTimeout(() => {
                        that.compliance[key].isSaved = false;
                    },
                        1500
                    )
                        ;
                }).catch(() => { that.compliance[key].isSaving = false; })
                    ;
            }
            if (key === 'payment') {
                this.$http.put('/orders/' + this.order.id, {
                    payment_method: this.order.payment_method,
                    bank_routing: this.order.bank_routing,
                    bank_account: this.order.bank_account,
                    paypal_email: this.order.paypal_email,
                }).then(response => {
                    console.log(response);
                    that.order.bank_routing_masked = response.data.data.bank_routing_masked;
                    that.order.bank_account_masked = response.data.data.bank_account_masked;
                    that.order.bank_routing_valid = response.data.data.bank_routing_valid;
                    that.compliance[key].isSaved = true;
                    that.compliance[key].isSaving = false;
                    that.compliance[key].isEditing = false;
                    setTimeout(() => {
                        that.compliance[key].isSaved = false;
                    },
                        1500
                    )
                        ;
                }).catch(() => { that.compliance[key].isSaving = false; })
                    ;
            }
            if (key === 'dob') {
                this.$http.put('/customers/' + this.order.customer.id, {
                    dob: this.order.customer.dob,
                }).then(response => {
                    console.log(response);
                    that.compliance[key].isSaved = true;
                    that.compliance[key].isSaving = false;
                    that.compliance[key].isEditing = false;
                    setTimeout(() => {
                        that.compliance[key].isSaved = false;
                    },
                        1500
                    )
                        ;
                }).catch(() => { that.compliance[key].isSaving = false; });
            }
            if (key === 'bonus_card') {
                this.$http.put('/orders/' + this.order.id, {
                    bonus_card_present: this.order.bonus_card_present
                }).then(response => {
                    console.log(response);
                    that.compliance[key].isSaved = true;
                    that.compliance[key].isSaving = false;
                    that.compliance[key].isEditing = false;
                    setTimeout(() => {
                        that.compliance[key].isSaved = false;
                    },
                        1500
                    )
                        ;
                }).catch(() => { that.compliance[key].isSaving = false; })
                    ;
            }
            if (key === 'ssn_last_4') {
                this.$http.put('/customers/' + this.order.customer.id, {
                    ssn_last_4: this.order.customer.ssn_last_4,
                }).then(response => {
                    console.log(response);
                    that.order.customer.ssn_last_4_masked = response.data.data.ssn_last_4_masked;
                    that.compliance[key].isSaved = true;
                    that.compliance[key].isSaving = false;
                    that.compliance[key].isEditing = false;
                    setTimeout(() => {
                        that.compliance[key].isSaved = false;
                    },
                        1500
                    )
                        ;
                }).catch(() => { that.compliance[key].isSaving = false; });
            }
        },

        // cancels any data edits/reverts to previous values
        cancelEdits(e) {
            let key = e.target.attributes['data-editing'].value;
            this.order = Object.assign({}, this.cachedOrderData);
            this.compliance[key].isEditing = false;
        },
        // mark all compliance categories as verified
        verifyAllCompliance() {
            let that = this;
            let data = ['signature', 'signature_card', 'identification', 'dob', 'payment', 'bonus_card', 'ssn_last_4'];
            data.forEach(function (dataItem) {
                that.compliance[dataItem].verified = true;
                that.compliance[dataItem].error = false;
            });
            this.compliance.allVerified = true;
        },

        setQA(type, data, trigger, isClicked = true, conformationCallback = function () { }) {
            // If scanned item is already verified, do nothing
            if (data && (type === 'bag' || type === 'inventory') && trigger === 'verify' && !isClicked && data.verified) {
                return;
            }

            if (trigger !== 'error' && data && ((trigger === 'verify' ? !data.verified : data.verified)) && isClicked && (type == 'inventory' || type == 'bag' || type == 'all' || type == 'all-hold')) {
                this.$refs.GenericPopups.displayPermission =
                {
                    title: 'Error',
                    permission: 'manage inventory',
                    text: 'Are you sure you want to move forward with a weight variance.',
                    okAction: () => { this.setQA(type, data, trigger, false, conformationCallback); },
                    ok: 'Yes, move forward',
                    endPointsLater: ['/qa/' + this.order.id]
                };
                return;
            }
            this.working = true;
            let toSave = {
                bags: [],
                inventory: [],
            };
            if (data && (type === 'bag' || type === 'inventory') && trigger === 'verify') {
                data.verified = !data.verified;
            }

            if (type === 'bag') {
                toSave.bags.push({ bag_id: data.bag_id, verified: data.verified, has_error: data.has_error });
                _.forEach(_.filter(this.QA.inventoryByMetal[data.class], ['bag_id', data.bag_id]), (item) => {
                    item.verified = data.verified;
                    toSave.inventory.push({
                        inventory_id: item.id,
                        verified: item.verified,
                    });
                });
            } else if (type === 'inventory') {
                toSave.inventory.push({
                    inventory_id: data.id,
                    verified: data.verified,
                    error: data.has_error,
                    subtype: data.error_type,
                    description: data.description
                });
                let bag = _.find(this.QA.bags, (m) => { return m.bag_id == data.bag_id; });
                if (bag) {
                    let oldVerified = bag.verified;
                    bag.verified = true; //small assumption its true until proven false.
                    _.forEach(_.filter(this.QA.inventoryByMetal[bag.class], ['bag_id', bag.bag_id]), (item) => {
                        if (!item.verified) {
                            bag.verified = false;
                        }
                    });
                    if (oldVerified != bag.verified) {
                        toSave.bags.push({ bag_id: bag.bag_id, verified: bag.verified, has_error: bag.has_error });
                    }
                }
            } else if (type === 'all') {
                _.forEach(this.QA.bags, (bag) => {
                    bag.verified = data.verified;
                    toSave.bags.push({ bag_id: bag.bag_id, verified: bag.verified });
                });
                _.forEach(this.QA.inventoryByMetal, (metalArray) => {
                    _.forEach(metalArray, (item) => {
                        item.verified = data.verified;
                        if (data.verified) {
                            item.error_type = null;
                        }
                        toSave.inventory.push({
                            inventory_id: item.id,
                            verified: item.verified,
                        });
                    });
                });
            } else if (type === 'all-hold') {
                _.forEach(this.QA.holds, (item) => {
                    item.verified = data.verified;
                    item.has_error = data.has_error;
                    if (data.verified) {
                        item.error_type = null;
                    }
                    toSave.inventory.push({
                        inventory_id: item.id,
                        verified: item.verified,
                        error: item.has_error,
                        error_type: item.error_type
                    });
                });
            }
            this.checkreadyForOfferGen();
            this.$forceUpdate();
            this.$http.post('/qa/' + this.order.id, toSave)
                .then(response => {
                    console.log(response);
                    this.working = false;
                    data._showDetails = false;
                    if (trigger == 'error') {
                        this.$bvToast.toast('QA has recorded the error', {
                            title: 'Successfully Saved',
                            variant: 'warning',
                            appendToast: true,
                            autoHideDelay: 3000,
                        });
                    } else {
                        this.$bvToast.toast('QA has saved the selected or scanned bags/items', {
                            title: 'Successfully Saved',
                            variant: 'success',
                            appendToast: true,
                            autoHideDelay: 3000,
                        });
                    }
                });
            conformationCallback();
        },

        printLabel(type, item) {
            if (type === 'bag') {
                let bag = _.find(this.bags, ['id', item.bag_id]);
                if (bag) {
                    bag.customer = this.order.customer;
                    bag.order = this.order;
                    item = bag;
                }
            } else {
                let bag = _.find(this.bags, ['id', item.bag_id]);
                item.customer = this.order.customer;
                item.order = this.order;
                if (type === 'hold') {
                    item.bag = bag;
                }
            }
            this.$label(type, item);
        },
        checkreadyForOfferGen() {
            this.readyForOfferGen = true;
            //all inventory
            _.forEach(this._getBagsByMetal, (bagArray) => {
                _.forEach(bagArray, (bag) => {
                    _.forEach(this._getMeltItems[bag.bag_id], (item) => {
                        if (
                            !item.verified
                        ) {
                            this.readyForOfferGen = false;
                        }
                    })
                        ;
                })
                    ;
            })
                ;
            //all hold items
            _.forEach(this.QA.holds, (item) => {
                if (
                    !item.verified
                ) {
                    this.readyForOfferGen = false;
                }
            })
                ;
            _.forEach(this.compliance, (item) => {
                if (item.verified == false && item.error == false
                ) {
                    this.readyForOfferGen = false;
                }
            })
                ;
        },
        scanNew() {
            this.$store.commit('setActiveOrder', null);
            this.$router.push('/quality-assurance');
        },
        setToInventoryHold() {
            this.$http.put('/orders/' + this.$route.params.id, { status_id: 6 }).then(() => {
                this.$refs.GenericPopups.displayError =
                {
                    title: 'Success',
                    text: 'Your order status has been updated.'
                };
            });
        },
        setToOfferGen() {
            console.log(this.getFlagsByType(39));
            if (this.getFlagsByType(39).length == 0) {
                this.$http.put('/orders/' + this.$route.params.id, { status_id: 7 }).then(() => {
                    this.$router.push('/offer-generation/view/' + this.$route.params.id);
                });
            } else {
                this.$parent.$bvModal.msgBoxOk('Suspicious activity is flagged on this order - please investigate. The flag must be cleared on this order to move forward.', {
                    title: 'Potentially Fraudulent Activity - Serial Number',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    headerClass: 'p-2 border-bottom-0 text-center d-block',
                    footerClass: 'p-2 border-top-0',
                });
            }
        },
        formatDate(date_str) {
            if (date_str) {
                return moment(String(date_str)).format('MM/DD/YYYY');
            }
            return date_str;
        },
        expandAll() {
            this.QA.bags.forEach((bag) => {
                bag._showDetails = true;
            });
            _.each(this._getBagsByMetal, (bagArray) => {
                _.each(bagArray, (bag) => {
                    bag._showDetails = true;
                    _.each(this._getMeltItems[bag.bag_id], (item) => {
                        item._showDetails = true;
                    });
                });
            });
            this.QA.holds.forEach((hold) => {
                hold._showDetails = true;
                hold.children.forEach((item) => {
                    item._showDetails = true;
                });
            });
        },
        collapseAll() {
            this.QA.bags.forEach((bag) => {
                bag._showDetails = false;
            });
            this.QA.holds.forEach((hold) => {
                hold._showDetails = false;
            });
        },
    },
    watch: {
        'compliance.signature.error'() {
            if (!this.loading_items) {
                this.working = true;
                this.compliance.signature.isSaving = true;
                let toSave = {
                    'order': {
                        verified: this.compliance.signature.verified,
                        error: this.compliance.signature.error,
                        error_type: 2,
                    }
                };
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.signature.isSaving = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.signature.verified'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.signature.verified,
                        error: this.compliance.signature.error,
                        error_type: 2,
                    }
                };
                this.working = true;
                this.compliance.signature.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.signature.isSaving = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },

        'compliance.signature.error_description'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        description: this.compliance.signature.error_description,
                        error_type: 2,
                    }
                };
                this.working = true;
                this.compliance.signature.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.signature.isSaving = false;
                    })
                    ;
            }
        },

        'compliance.signature_card.error'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.signature_card.verified,
                        error: this.compliance.signature_card.error,
                        error_type: 1,
                    }
                };
                this.working = true;
                this.compliance.signature_card.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.compliance.signature_card.isSaving = false;
                        this.working = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.signature_card.verified'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.signature_card.verified,
                        error: this.compliance.signature_card.error,
                        error_type: 1,
                    }
                };
                this.working = true;
                this.compliance.signature_card.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.signature_card.isSaving = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.signature_card.error_description'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        description: this.compliance.signature_card.error_description,
                        error_type: 1,
                    }
                };
                this.working = true;
                this.compliance.signature_card.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.signature_card.isSaving = false;
                    })
                    ;
            }
        },

        'compliance.identification.error'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.identification.verified,
                        error: this.compliance.identification.error,
                        error_type: 3,
                    }
                };
                this.working = true;
                this.compliance.identification.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.identification.isSaving = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.identification.verified'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.identification.verified,
                        error: this.compliance.identification.error,
                        error_type: 3,
                    }
                };
                this.working = true;
                this.compliance.identification.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.identification.isSaving = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.identification.error_description'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        description: this.compliance.identification.error_description,
                        error_type: 3,
                    }
                };
                this.working = true;
                this.compliance.identification.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.compliance.identification.isSaving = false;
                        this.working = false;
                    })
                    ;
            }
        },
        'compliance.payment.error'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.payment.verified,
                        error: this.compliance.payment.error,
                        error_type: 4,
                    }
                };
                this.working = true;
                this.compliance.payment.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.payment.isSaving = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.payment.verified'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.payment.verified,
                        error: this.compliance.payment.error,
                        error_type: 4,
                    }
                };
                this.compliance.payment.isSaving = true;
                this.working = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.compliance.payment.isSaving = false;
                        this.working = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },

        'compliance.payment.error_description'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        description: this.compliance.payment.error_description,
                        error_type: 4,
                    }
                };
                this.working = true;
                this.compliance.payment.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.payment.isSaving = false;
                    })
                    ;
            }
        },

        'compliance.dob.error'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.dob.verified,
                        error: this.compliance.dob.error,
                        error_type: 24,
                    }
                };
                this.working = true;
                this.compliance.dob.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.dob.isSaving = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.dob.verified'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.dob.verified,
                        error: this.compliance.dob.error,
                        error_type: 24,
                    }
                };
                this.compliance.dob.isSaving = true;
                this.working = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.compliance.dob.isSaving = false;
                        this.working = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.dob.error_description'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        description: this.compliance.dob.error_description,
                        error_type: 24,
                    }
                };
                this.working = true;
                this.compliance.dob.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.compliance.dob.isSaving = false;
                        this.working = false;
                    })
                    ;
            }
        },

        'compliance.bonus_card.error'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.bonus_card.verified,
                        error: this.compliance.bonus_card.error,
                        error_type: 25,
                    }
                };
                this.working = true;
                this.compliance.bonus_card.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.compliance.bonus_card.isSaving = false;
                        this.working = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.bonus_card.verified'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.bonus_card.verified,
                        error: this.compliance.bonus_card.error,
                        error_type: 25,
                    }
                };
                this.working = true;
                this.compliance.bonus_card.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.bonus_card.isSaving = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.bonus_card.error_description'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        description: this.compliance.bonus_card.error_description,
                        error_type: 25,
                    }
                };
                this.working = true;
                this.compliance.bonus_card.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.bonus_card.isSaving = false;
                    })
                    ;
            }
        },

        'compliance.ssn_last_4.error'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.ssn_last_4.verified,
                        error: this.compliance.ssn_last_4.error,
                        error_type: 26,
                    }
                };
                this.working = true;
                this.compliance.ssn_last_4.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.working = false;
                        this.compliance.ssn_last_4.isSaving = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.ssn_last_4.verified'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        verified: this.compliance.ssn_last_4.verified,
                        error: this.compliance.ssn_last_4.error,
                        error_type: 26,
                    }
                };
                this.compliance.ssn_last_4.isSaving = true;
                this.working = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.compliance.ssn_last_4.isSaving = false;
                        this.working = false;
                    })
                    ;
            }
            this.checkreadyForOfferGen();
        },
        'compliance.ssn_last_4.error_description'() {
            if (!this.loading_items) {
                let toSave = {
                    'order': {
                        description: this.compliance.ssn_last_4.error_description,
                        error_type: 26,
                    }
                };
                this.working = true;
                this.compliance.ssn_last_4.isSaving = true;
                this.$http.post('/qa/' + this.order.id, toSave)
                    .then(response => {
                        console.log(response);
                        this.compliance.ssn_last_4.isSaving = false;
                        this.working = false;
                    })
                    ;
            }
        },

        _isFlagUpdated: {
            immediate: true,
            deep: true,
            handler(flag) {
                if (this.order) {
                    let i;
                    for (i = 0; i < this.order.flags.length; i++) {
                        if (this.order.flags[i].id == flag.id) {
                            this.order.flags[i] = flag;
                            return;
                        }
                    }
                    this.order.flags[i] = flag;
                }
            }
        },

    }


};
</script>

<style scoped>
.table-default {
    background-color: #dfdfdf !important;
}

.table-header-bg {
    background: #1a415d;
    color: #fff;
}

.bg-warning-light {
    background: #ffeeba;
}

.editable .controls .fa-solid {
    font-size: 18px;
    transition: .2s ease;
}

.editable .controls .fas:hover {
    transform: scale(1.2);
}

.editable .data {
    position: relative;
    padding-left: 14px;
    padding-right: 12px;
}

.editable .data .fa-check-circle {
    position: absolute;
    left: 0;
    top: 4px;
}

.editable .data:hover {
    background: #f6f6f6;
    cursor: pointer;
    position: relative;

}

.editable .data:hover:after {
    font-family: 'Font Awesome 5 Pro';
    content: "\f14b";
    position: absolute;
    right: 0px;
    top: 0;
    color: lightcoral;
    font-size: 12px;
}

.onSave {
    animation: saved 1.5s linear;
    position: absolute;
    right: 0;
}

@keyframes saved {
    30% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.inventory-table {
    padding: 0 0 0 60px;
}

.metal-header {
    background-color: rgba(26, 65, 93, 1);
    color: white;
}

#compliance-section .form-group {
    margin-bottom: 0.2rem;
}

#compliance-section .editable .data {
    padding-bottom: 0;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option {
    padding: 8px !important;
    line-height: 10px !important;
    min-height: 20px !important;
    font-size: 0.8em;
}

.multiselect__tags,
.multiselect__select {
    padding: 0;
    margin-left: 2px;
    min-height: 33px !important;
    height: 33px !important;
    max-height: 33px !important;
}

.multiselect__placeholder {
    margin-left: 4px;
}

.multiselect__single {
    margin-top: 3px;
    font: 400 13px Arial;
}

.multiselect__tags {
    padding-top: 4px;
}

.multiselect {
    min-height: 33px !important;
    height: 33px !important;
    max-height: 33px !important;
}

.multiselect__option--group.multiselect__option--disabled {
    font-weight: bold;
    color: black !important;
}
</style>
